import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import queryString from 'query-string'

const resources = {
    tr: {
        translation: {
            'Browser': 'Tarayıcı',
            'metaData': 'Meta Veri',
            'No package information is available to display. Please contact the support team for assistance.' : 'Görüntülenecek paket bilgisi yok. Lütfen yardım için destek ekibiyle iletişime geçin',
            'Continue': 'Devam Et',
            'No Device ID Found' : 'Cihaz ID bulunamadı',
            'Add to Blacklist': 'Kara Listeye Ekle',
            'Which picture do you want to put on the blacklist?':
                'Hangi görseli kara listeye eklemek istiyorsunuz?',
            'The photo on the ID': 'Kimlik üzerindeki fotoğraf',
            'The face in the liveness video': 'Canlılık videosundaki yüz',
            'Blacklisting failed': 'Karalisteye ekleme başarısız',
            'Successfully added to blacklist': 'Karalisteye başarıyla eklendi',
            'Are you sure you want to blacklist the images?':
                'Görselleri kara listeye eklemek istediğinizden emin misiniz?',
            'Add To Blacklist': 'Karalisteye Ekle',
            'No data found': 'Veri Bulunamadı',
            'Usage Statistics': 'Kullanım İstatistiği',
            'Process': 'İşlem',
            'GENDERSIMILARITY': 'Cinsiyet Benzerliği',
            'AGESIMILARITY': 'Yaş Benzerliği',
            'LIVENESSGENDERSIMILARITY': 'Canlılık Cinsiyet Benzerliği',
            'LIVENESSAGESIMILARITY': 'Canlılık Yaş Benzerliği',
            'Device': 'Cihaz',
            'SCREENATTACKFRONT': 'Ekran Saldırısı',
            'FRAMESCREENATTACKFRONT': 'Çerçeveden Ekran Saldırısı Tespiti',
            'FRAMESCREENATTACKBACK': 'Çerçeveden Ekran Saldırısı Tespiti Arka Yüz',
            'TAMPERDETECTION': 'Tahrifat Algılama',
            'TAMPERDETECTIONBACK': 'Tahrifat Algılama Arka Yüz',
            'Delete User': 'Kullanıcıyı Sil',
            'Confirmation Check': 'Onay Metni Kontrolü',
            'transactionType': 'İşlem Türü',
            'Call has been stopped by remote user': 'Görüşme uzak kullanıcının sonlandırmasıyla sonlandırıldı',
            'idType': 'Kimlik Türü',
            'handLandmarks': 'El Referans Noktası',
            'Are you sure you want to activate the user?':
                'Kullanıcıyı aktife çekmek istediğinizden emin misiniz?',
            'Are you sure you want to deactivate the user?':
                'Kullanıcıyı pasife almak istediğinizden emin misiniz?',
            'Switch User Status': 'Kullanıcının Durumunu Değiştir',
            'Pending for Deactivation': 'Pasife Alınmak İçin Bekliyor',
            'Users to Be Deactivated': 'Pasife Alınacak Kullanıcılar',
            'You can not paste any text here!': 'Bu alana metin yapıştıramazsınız',
            'Close': 'Kapat',
            '_newidfront': 'Yeni Kimlik',
            '_hiddenphoto': 'Gizli Fotoğraf',
            'prove_result': 'Kanıtlanmış Sonuçlar',
            'user_details': 'Kullanıcı Detayları',
            'id_number': 'Kimlik Numarası',
            'MRZEXPDATECHECKSUMVALID': 'Son Geçerlilik Tarihi Kontrol Basamağı Doğruluğu',
            'MRZBIRTHDATECHECKSUMVALID': 'Doğum Tarihi Kontrol Basamağı Doğruluğu',
            'MRZDOCNUMCHECKSUMVALID': 'Seri Numarası Kontrol Basamağı Doğruluğu',
            'HOLOGRAMSERIALSIMILARITY': 'Hologram ile Seri Numarası Benzerlik Puanı',
            'HOLOGRAMBDATESIMILARITY': 'Hologram ile Doğum Günü Benzerlik Puanı',
            'HOLOGRAMEDATESIMILARITY': 'Hologram ile Son Geçerlilik Tarihi Benzerlik Puanı',
            'AGE': 'Kimlik Fotoğrafı ile Yaş Tahmini',
            'GENDER': 'Kimlik Fotoğrafı ile Cinsiyet Tahmini',
            'LIVENESSGENDER': 'Canlılık ile Cinsiyet Tahmini',
            'LIVENESSAGE': 'Canlılık ile Yaş Tahmini',
            'LIVENESSFACEBLACKLISTSCORE': 'Canlılık ile Kara Listedeki Yüzlerin Benzerlik',
            'PHOTOCHEAT': 'Kimlik Fotoğrafı Doğrulaması',
            'HOLOGRAM': 'Hologram Algılama',
            'HOLOGRAMFACE': 'Hologram ile Yüz Benzerlik Puanı',
            'HOLOGRAMIDSIMILARITY': 'Hologram ile TCKN Benzerlik Puanı',
            'FACELIVENESSGESTURE': 'Mimik Algılama',
            'FACELIVENESSFACECONSPER': 'Canlılıkta Geçerli Yüz Oranı',
            'FACELIVENESSFACECONSAVG': 'Canlılıkta Ortalama Yüz Benzerlik Puanı',
            'FACELIVENESSAI': 'Canlılık Yapay Zeka Puanı',
            'FACEBLACKLISTSCORE': 'Kimlik Fotoğrafı ile Kara Listedeki Yüzlerin Benzerliği',
            'FACESEARCHEXISTENCE': 'Face Search Veritabanında Bulunma',
            'IDTYPEIDENTIFICATION': 'Kimlik Tipi Tespiti',
            'SUNGLASSESDETECTION': 'Güneş Gözlüğü Bulunma Kontrolü',
            'FACELIVENESSEYEMOVEMENT': 'Göz Hareketi Kontrolü',
            'BDV': 'Doğum Günü Geçerlilik Kontrolü',
            'EDV': 'Son Geçerlilik Tarihi Geçerlilik Kontrolü',
            'SNV': 'Seri Numarası Geçerlilik Kontrolü',
            'AFR': 'Tüm Alanların Okunması Kontrolü',
            'PRESENTATIONIMAGEAI': 'Yüz Yapay Zeka Puanı',
            'FACEIMAGEAI_1': '1. Yüz Yapay Zeka Puanı',
            'FACEIMAGEAI_2': '2. Yüz Yapay Zeka Puanı',
            'FWVEMOTION_APPROVAL': 'Onay Metni Kontrolünde Duygu Analizi',
            'ID Front Checks': 'Kimlik Ön Yüz Kontrolleri',
            'ID Back Checks': 'Kimlik Arka Yüz Kontrolleri',
            'Tamper Detections': 'Tahrifat Algılama',
            'Finger Placement on ID Checks': 'Kimliği Parmak ile Kapatma Adımı Kontrolleri',
            'Hologram Video Checks': 'Hologram Videosu Kontrolleri',
            'NFC Checks': 'NFC Kontrolleri',
            'Selfie with ID Checks': 'Kimlikli Selfie Kontrolleri',
            'Liveness Video Checks': 'Canlılık Videosu Kontrolleri',
            'Serial Number Verification Checks': 'Seri No Doğrulama Kontrolleri',
            'Voice Confirmation Checks': 'Sesli Onay Kontrolleri',
            'Other Checks': 'Diğer Kontroller',
            'FACELIVENESS': 'Toplam Canlılık Skoru',
            'FACE': 'Canlılık ile Yüz Benzerlik Puanı',
            'HIDDENPHOTO': 'Gizli Fotoğraf Algılama',
            'HIDDENPHOTOOCR': 'Gizli Fotoğraf Kod Kontrolü',
            'SIGNATUREPHOTO': 'İmza Algılama',
            'MRZOCRCROSSSIMILARITY': 'MRZ - OCR Çapraz Benzerliği',
            // Archive titles
            'ID Front Archive': 'Kimlik Ön Yüz Arşivi',
            'ID Back Archive': 'Kimlik Arka Yüz Arşivi',
            'ID Front Uncropped': 'Kimlik Ön Yüz Kırpılmamış',
            'ID Back Uncropped': 'Kimlik Arka Yüz Kırpılmamış',
            'Fingerprint Archive': 'Parmak İzi Arşivi',
            'Finger Placement Archive': 'Kimliği Parmakla Kapatma Arşivi',
            'Hologram Video Archive': 'Hologram Arşivi',
            'NFC Portrait Archive': 'NFC Portre Arşivi',
            'Selfie with ID Archive': 'Kimlikli Selfie Arşivi',
            'Liveliness Video Archive': 'Canlılık Video Arşivi',
            'Serial Number Verification Archive': 'Seri No Doğrulama Videosu Arşivi',
            'Voice Confirmation Archive': 'Sesli Onay Videosu Arşivi',
            'ID Face Archive': 'Kimlik Portesi Arşivi',
            'Signature Archive': 'İmza Arşivi',
            'Hidden Photo Archive': 'Gizli Foto Arşivi',
            'Liveness with ID Card Archive': 'Kimlikli Selfie Ön Yüz Arşivi',
            'Liveness with ID Card Back Archive': 'Kimlikli Selfie Arka Yüz Arşivi',
            'Users To Be Activated': 'Aktife Çekilecek Kullanıcılar',   
            'Voice Liveness Serial': 'Sesli Canlılık Seri',
            'Voice Liveness Approval': 'Sesli Canlılık Onay',
            'Voice Liveness Audio Serial': 'Sesli Canlılık Ses Seri',
            'Voice Liveness Audio Approval': 'Sesli Canlılık Ses Onay',
            'Voice Liveness Frame Approval': 'Sesli Canlılık Frame Onay',
            'Liveness with ID Card': 'Kartı Tutarak Canlılık',
            'GUILLOCHEVERIFICATION': 'Guilloche Algılama',
            'RAINBOWVERIFICATION': 'Gökkuşağı Algılama',
            'MRZNFCSIMILARITY': 'MRZ - NFC Eşleştirme',
            'MRZOCRSIMILARITY': 'MRZ - OCR Eşleştirme',
            'DRIVERBARCODEIDMATCH': 'Ehliyet Barkod Kontrolü',
            'IDCARDBARCODEIDMATCH': 'Kimlik Barkod Kontrolü ',
            'IDDOCIDMATCH': 'Belgenin TCKN Uyumu',
            'IDDOCNAMEMATCH': 'Belgenin İsim Uyumu',
            'IDDOCSURNAMEMATCH': 'Belgenin Soyisim Uyumu',
            'MRZBIRTHDATECHECKSUM': 'Doğum Tarihi Kontrol Basamağı',
            'MRZEXPDATECHECKSUM': 'Son Geçerlilik Tarihi Kontrol Basamağı',
            'MRZDOCNUMCHECKSUM': 'Seri Numarası Kontrol Basamağı',
            'NFCMRZSIMILARITY': 'NFC - MRZ Benzerliği',
            'NFCOCRFACESIMILARITY': 'NFC - OCR Yüz Benzerliği',
            'NFCOCRSIMILARITY': 'NFC - OCR Benzerliği',
            'AMLVALIDATION': 'AML Kontrolü',
            'FACESIMILARITY': 'Yüz Benzerlik Puanı',
            'NVIPROVEIDWITHHOLDER': 'NVI Kontrolü',
            'OCRLETTERCASEMATCH': 'Beklenen Harf Büyüklüğü Kontrolü',
            'OCRMRZSIMILARITY': 'OCR - MRZ Benzerliği',
            'OCRNFCFACESIMILARITY': ' OCR - NFC Yüz Benzerliği',
            'OCRNFCSIMILARITY': 'OCR - NFC Benzerliği',
            'OLDIDSECONDARYINFORMATION': 'Beklenen Alan Uyumu Kontrolü',
            'IDCARD': 'TR Kimlik Kartı',
            'OLDIDCARD': 'Eski Kimlik',
            'PASSPORT': 'Pasaport',
            'DRIVERCARD': 'TR Ehliyet',
            'FOREIGNID': 'İkamet İzin Belgesi',
            'FOREIGNIDTYPEA': 'İkamet İzin Belgesi',
            'FOREIGNIDTYPEB': 'İkamet İzin Belgesi',
            'FOREIGNIDTYPEC': 'İkamet İzin Belgesi',
            'FOREIGNIDTYPED': 'Geçici Koruma Belgesi',
            'SCREENATTACK': 'Ekran Saldırısı Güvenliği',
            'oldidfront': 'Eski Kimlik Ön Yüzü (İşlenmiş) ',
            'passport': 'Pasaport',
            'driverface': 'Sürücü Belgesi Portre',
            'newdriverfront': 'Sürücü Belgesi',
            'turkishbluecardface': 'Mavi Kart Portre',
            'turkishbluecardfront': 'Mavi Kart Ön Yüz',
            'ocr': 'OCR',
            'Name Surname': 'Ad Soyad',
            'Registration Date': 'Kayıt Tarihi',
            'Submitted Files': 'Gönderilen Dosyalar',
            'Submit': 'Kaydet',
            'Status': 'Durum',
            'All Status': 'Tüm Durumlar',
            'Verification Score': 'Doğrulama Puanı',
            'Agent': 'Müşteri Temsilcisi',
            'agent': 'Temsilci',
            'agent_lead': 'Temsilci Lideri',
            'admin': 'Yönetici',
            'Control': 'Kontrol',
            'Result': 'Sonuç',
            'Outcome': 'Çıktı',
            'Entry Type': 'Giriş Türü',
            'Entry Score': 'Giriş Puanı',
            'Entry Interpretation': 'Giriş Yorumu',
            'Validation': 'Doğrulama',
            'Acceptable': 'Kabul Edilebilir',
            'Media Type': 'Ortam Türü',
            'Actions': 'Aksiyonlar',
            'Open': 'Aç',
            'Download': 'İndir',
            'Meta Title': 'Üst Başlık',
            'Value': 'Değer',
            'Info Title': 'Bilgi Başlığı',
            "Couldn't get media information": 'Medya bilgisi alınamadı',
            'The selected file is a ZIP archive and cannot be previewed directly. Please download the file to view its contents.':
                'Seçilen dosya bir ZIP arşividir ve doğrudan önizlenemez. İçeriğini görüntülemek için lütfen dosyayı indirin.',
            "Couldn't get export": 'Dışa aktarılamadı',
            'Identity Acceptable': 'Kimlik Kabul Edilebilir',
            'Identity Information Validity': 'Kimlik Bilgilerinin Geçerliliği',
            'Biometric Photo Validity': 'Biyometrik Fotoğraf Geçerliliği',
            'Encryption Validity': 'Şifreleme Geçerliliği',
            'Certificate Validity': 'Sertifika Geçerliliği',
            'Created At': 'Oluşturma Tarihi',
            'Name': 'Ad',
            'Surname': 'Soyad',
            'Birth Date': 'Doğum Tarihi',
            'Document Type': 'Doküman Tipi',
            'Identity No': 'Kimlik No',
            'Expiry Date': 'Son Geçerlilik Tarihi',
            'Delete Confirmation': 'Silme Onayı',
            'The data you selected will be completely removed. Do you want to continue?':
                'Seçtiğiniz veriler tamamen kaldırılacak. Devam etmek istiyor musunuz?',
            'Cancel': 'İptal',
            'Confirm': 'Onayla',
            'Control Results': 'Kontrol Sonuçları',
            'Confidence': 'Doğruluk',
            'Identity': 'Kimlik',
            'Video & Image': 'Video ve Resim',
            'Metadata': 'OCR Sonuçları & Üst Veri',
            'NFC Controls': 'NFC Sertifika Kontrolleri',
            'Please Wait...': 'Lütfen bekleyin...',
            'Details': 'Detaylar',
            'Export': 'Dışa Aktar',
            'Report': 'Rapor',
            'Rows per page:': 'Sayfa başına satır sayısı',
            'Home': 'Anasayfa',
            'Person': 'Kişi',
            'User Information': 'Kullanıcı Bilgilerim',
            'Logout': 'Çıkış Yap',
            'Support': 'Destek',
            'Verifications': 'Doğrulamalar',
            'Verification Details': 'Doğrulama Detayları',
            'Verification Result': 'Doğrulama Sonucu',
            'Quality Monitoring': 'Kalite Dinlemesi',
            'Quality Listening Status': 'Kalite Dinlemesi Durumu',
            'Quality Listening Date': 'Kalite Dinlemesi Tarihi',
            'Quality Controller': 'Kalite Kontrolörü',
            'Video Call Agent': 'Görüntülü Görüşme Temsilcisi',
            'Quality Listening Done': 'Kalite Dinlemesi Yapıldı',
            'Quality Notes': 'Kalite Notları',
            'Save Quality Information': 'Kalite Bilgilerini Kaydet',
            'Awaiting Calls': 'Bekleyen Aramalar',
            'Video Call': 'Görüntülü Görüşme',
            'Call': 'Ara',
            'Waiting Time': 'Bekleme Zamanı',
            'You will return to back page. Do you want to continue?':
                'Giriş sayfasına geri döneceksiniz. Devam etmek istiyor musunuz?',
            'ID Info': 'Kimlik Bilgisi',
            'NFC Info': 'NFC Bilgisi',
            'Controls': 'Kontroller',
            'Signing, Please Wait...': 'Giriş yapılıyor, Lütfen bekleyiniz...',
            'Customers': 'Müşteriler',
            'oldidface': 'Eski Kimlik Yüz',
            'Search Name': 'Ada Göre Arayınız',
            'Last Attempt': 'Son Deneme',
            'Phone': 'Telefon',
            'E-Mail': 'E-Posta',
            'User': 'Kullanıcı',
            'Customer Details': 'Müşteri Detayı',
            'Transaction ID': 'İşlem ID',
            'Verification Date': 'Onaylama Tarihi',
            'city': 'Şehir',
            'country': 'Ülke',
            'device': 'Cihaz',
            'ip': 'IP',
            'language': 'Dil',
            'Document No': 'Seri No',
            'Licence Number': 'Sürücü Sicil Numarası',
            'Passport No': 'Pasaport No',
            'Awaiting Documents': 'Bekleyen Belgeler',
            'Confirm Document': 'Dokümanı Onayla',
            'Confirmed Documents': 'Onaylanmış Belgeler',
            'Document Details': 'Doküman Detayları',
            'Identity Number': 'Kimlik Numarası',
            'This document was marked as CONFIRMED.': 'Dokümanı GEÇERLİ olarak işaretledin.',
            'Do you confirm?': 'Onaylıyor musun?',
            'Check Again': 'Tekrar Kontrol Et',
            'This document was REJECTED.': 'Dokümanı REDDETTİN.',
            'Choose the reason for rejection': 'Red sebebini seçin',
            'The document has expired': 'Belge geçerliliğini yitirmiş',
            'Document not found': 'Belge bulunamadı',
            'not-found': 'Belge bulunamadı',
            'Document type wrong': 'Belge tipi yanlış',
            'Confirmation Date': 'Onay Tarihi',
            'Confirmation Status': 'Onay Durumu',
            'Save': 'Kaydet',
            'Confirm or decline this document.': 'Bu belgeyi onaylayın veya reddedin.',
            'Operation Completed': 'İşlem Tamamlandı',
            'You are closing the selected document without making any choice. This document will not be available for confirmation for 3 minutes. Do you confirm?':
                'Bir işaretleme yapmadan seçtiğin dokümanı kapatıyorsun. Bu doküman 3 dakika boyunca onay için erişilebilir olmayacak. Kapatma işlemini onaylıyor musun?',
            'Go back to the document': 'Dokümana Geri Dön',
            'Change as Declined': 'Reddedildi Olarak Değiştir',
            'Change as Approved': 'Onaylandı Olarak Değiştir',
            'Do you want to change?': 'Değiştirmek istiyor musunuz?',
            'Document current status': 'Dökümanın güncel durumu',
            'DECLINED': 'REDDEDİLDİ',
            'Personel Incorrect Entry': 'Personel Hatalı Giriş',
            'Document Barcode Number Incorrect Entry': 'Döküman Barkod Numarası Hatalı Giriş',
            'TCKN Incorrect Entry': 'TCKN Hatalı Giriş',
            'Why is the document\'s "Approved" status changed to "Declined"?':
                'Dökümanın "Onaylandı" durumunun "Reddedildi" olarak değiştirme sebebi nedir?',
            'Why is the document\'s "Declined" status changed to "Approved"?':
                'Dökümanın "Reddedildi" durumunun "Onaylandı" olarak değiştirme sebebi nedir?',
            'Date': 'Tarih',
            'Action': 'Aksiyon',
            'Document History': 'Belge Geçmişi',
            'Blue Card': 'Mavi Kart',
            'Residence Permit': 'İkamet İzni',
            'Temporary Protection ID': 'Geçici Koruma Belgesi',
            'German ID Card': 'Almanya Kimlik Kartı',
            'Approved': 'Onaylandı',
            'Document Detail': 'Belge Detayı',
            'Verification Detail': 'Doğrulama Detayı',
            'Change Status': 'Onay Durumunu Değişir',
            'Please enter same password': 'Lütfen aynı şifreyi girin',
            'Back To Panel': 'Panele Dön',
            'Could not change your password': 'Şifreniz değiştirilemedi',
            'Old Password': 'Eski Şifre',
            'New Password': 'Yeni Şifre',
            'Confirm New Password': 'Yeni Şifreyi Doğrula',
            'Save Password': 'Şifremi kaydet',
            'Change Password': 'Şifre Değiştir',
            'Forgot Password?': 'Şifreni mi unuttun?',
            'Reset Password': 'Şifremi Sıfırla',
            'E-mail': 'E-posta',
            'Return': 'Geri Dön',
            'Create New Password': 'Yeni Şifre Oluştur',
            'Could not reset your password': 'Şifreniz sıfırlanamadı',
            'Check your E-mail': 'E-postanızı kontrol edin',
            'Check your username': 'Kullanıcı adınızı kontrol edin',
            'Username': 'Kullanıcı adı',
            'Mobile Number': 'Telefon numarası',
            'Roles': 'Roller',
            'All Users': 'Tüm Kullanıcılar',
            'Sign In': 'Giriş Yap',
            'Password': 'Şifre',
            'Remember Me': 'Beni hatırla',
            'Create User': 'Kullanıcı Oluştur',
            'Approve Users': 'Kullanıcı Onayla',
            'Approve': 'Onayla',
            'Decline': 'Reddet',
            'Create': 'Oluştur',
            'User Approval Screen': 'Onay Bekleyen Kullanıcılar',
            'The document is not original': 'Belge orijinal değil',
            'Select a reason for rejection of the document':
                'Belgenin reddedilmesi için bir neden seçin',
            'Uploaded': 'Yüklendi',
            'Awaiting': 'Bekliyor',
            'Declined: Expired document': 'Reddedildi: Geçerli değil',
            'Declined: Document not found': 'Reddedildi: Bulunamadı',
            'Declined: Document type wrong': 'Reddedildi: Yanlış tip',
            'Declined: Document is not original': 'Reddedildi: Belge orijinal değil',
            'Changed to declined: TCKN Incorrect Entry':
                'Reddedildi olarak değiştirildi: TCKN hatalı giriş',
            'Changed to declined: Document Barcode Number Incorrect Entry':
                'Reddedildi olarak değiştirildi: Barkod hatalı giriş',
            'Changed to declined: Personel Incorrect Entry':
                'Reddedildi olarak değiştirildi: Personel hatalı giriş',
            'Declined': 'Reddedildi',
            'Changed to approved: Personel Incorrect Entry':
                'Onaylandı olarak değiştirildi: Personel hatalı giriş',
            'All': 'Hepsi',
            'ONBOARD': 'Onboard',
            'PASSWORD': 'Şifre',
            'Process Type': 'İşlem Türü',
            'Clear All': 'Hepsini temizle',
            'Search': 'Ara',
            'Additional Info': 'Ek Bilgiler',
            'Phone Number': 'Telefon numarası',
            'identity_no': 'Kimlik No',
            'name': 'Ad',
            'surname': 'Soyad',
            'birthdate': 'Doğum Günü',
            'document_no': 'Döküman No',
            'valid_until': 'Geçerlilik',
            'nationality': 'Uyruk',
            'gender': 'Cinsiyet',
            'mother_name': 'Anne Adı',
            'father_name': 'Baba Adı',
            'birth_place': 'Doğum Yeri',
            'alternativeName': 'Alternatif Ad',
            'alternativeSurname': 'Alternatif Soyad',
            'The operation could not be performed due to an error.':
                'Alınan bir hata sebebiyle işlem gerçekleştirilemedi.',
            'We Value Your Privacy Preferences':
                'Kişisel Verilerin Korunması ve İşlenmesine Yönelik Aydınlatma',
            'This website gathers information about user interaction, personel information and biometric characteristics for secure consent collection.  This sensitive information will only enable you to sign documents securely and verifiably and will not be shared with third parties without your consent. Please confirm your consents to proceed.':
                'Özel hayatınızın gizliliğine saygı duyuyor ve önem veriyoruz. Bu nedenle, “temel hak ve özgürlüklerinizi korumak amacıyla yürürlükte olan kanun” kapsamındaki kişisel verilerinizin kullanımı hakkında onayınızı almak istiyoruz.',
            'I have read and accepted the GDPR Complience':
                'KVKK Aydınlatma Metni’ni okudum ve kabul ediyorum',
            'Transaction Id': 'İşlem kodu',
            'Video Call ID': 'Görüntülü Görüşme ID\'si',
            'Gesture': 'Mimik',
            'Please select valid date ranges': 'Lütfen geçerli tarih aralığ seçiniz',
            'ID Type': 'Kimlik Tipi',
            'Progress': 'İlerleme',
            'ID Front': 'Kimlik ön yüz',
            'ID Back': 'Kimlik arka yüz',
            'Address Document': 'Adres Dökümanı',
            'Biometric Recognition & Verification': 'Biyometrik Tanıma & Doğrulama',
            'Please select one of the following identification documents for verification.':
                'Doğrulama için lütfen aşağıdaki kimlik belgelerinden birini seçin.',
            'For verification, first your ID photo, then your face photo is taken':
                'Doğrulama için önce kimlik fotoğrafınız, daha sonra yüzünüzün fotoğrafı çekilir',
            'The verification result is created by evaluating the identity and face information.':
                'Kimlik ve yüz bilgilerini değerlendirilerek doğrulama sonucu oluşturulur',
            'Authentications without user creation cannot be connected with any account and all information is deleted when you leave the page':
                'Kullanıcı oluşturmadan yapılan doğrulamalar herhangi bir hesapla bağlanamaz ve sayfayı terk ettiğinizde tüm bilgiler silinir',
            'Authentications made by creating a user are linked to the user account and the results can be viewed through the ProveID Dashboard panel.':
                'Kullanıcı oluşturularak yapılan doğrulamalar kullanıcı hesabına bağlanır ve sonuçlar ProveID Dashboard paneli üzerinden izlenebilir.',
            'EXPIREDOC': 'Belge geçerliliği yitirmiş',
            'NOTFOUNDDOC': 'Belge bulunamadı',
            'WRONGDOCTYPE': 'Belge tipi yanlış',
            'NOTORIGINAL': 'Belge orijinal değil',
            'select_language': 'Ülke Seçiniz',
            'select_language_desc':
                'Lütfen kimlik kartı ile doğrulmaya devam etmek için ülkenizi seçiniz.',
            'select_template': 'Şablon Tipini seçin',
            'select_template_desc':
                'Kimlik kart doğrulaması ile devam etmek için lütfen şablon tipinizi seçiniz.',
            'FOREIGNIDBACK': 'Yabancı Kimlik (Arka)',
            'Go Back To Dashboard': 'Yönetim Paneline Geri Dön',
            'ID-Front': 'Kimlik Kartı Ön Yüz',
            'ID-Back': 'Kimlik Kartı Arka Yüz',
            'ID': 'Kimlik Kartı',
            'ID-NFC': 'NFC Okuma',
            'Hologram': 'Hologram Videosu',
            'Others': 'Diğer Kontroller',
            'Order': 'Sıra',
            'Prev': 'Geri',
            'Next': 'İleri',
            'Media from the App': 'Uygulamada Alınan Medyalar',
            'Media from the Video Call': 'Görüntülü Görüşmede Alınan Medyalar',
            'Compare All Media': 'Tüm Medyaları Karşılaştır',
            'Start Time (Newest → Oldest)': 'Başlama zamanına göre (En yeni → En eski)',
            'Start Time (Oldest → Newest)': 'Başlama zamanına göre (En eski → En yeni)',
            'Updated Time (Newest → Oldest)': 'Güncellenme zamanına göre (En yeni → En eski)',
            'Updated Time (Oldest → Newest)': 'Güncellenme zamanına göre (En eski → En yeni)',
            'By First Name (A → Z)': 'Ada göre (A → Z)',
            'By First Name (Z → A)': 'Ada göre (Z → A)',
            'By Last Name (A → Z)': 'Soyada göre (A → Z)',
            'By Last Name (Z → A)': 'Soyada göre (Z → A)',
            'Media': 'Medyalar',
            'Export Report': 'Raporu Aktar',
            'Control Details': 'Kontrol Sonuçları',
            'Call Ended': 'Görüşme Sonlandırıldı',
            'Take Photo Preview': 'Fotoğraf Önizleme',
            'Shot Again': 'Tekrar Çek',
            'Save and Continue': 'Kaydet ve Devam Et',
            'Please wait... Capturing photo!': 'Lütfen bekleyiniz... Fotoğraf çekiliyor',
            'Video Recording Stopped': 'Video kaydı sonlandırıldı',
            'Video Recording Started': 'Video kaydı başlatıldı',
            'Photo successfully captured': 'Fotoğraf başarıyla çekildi',
            'Photo Successfully Saved': 'Fotoğraf başarıyla kaydedildi',
            'Start Recording': 'Kaydı Başlat',
            'Stop Recording': 'Kaydı Durdur',
            'Screen recording started': 'Ekran kaydı başlatıldı',
            'Screen recording saved': 'Ekran kaydı kaydedildi',
            'Screen recording downloaded': 'Ekran kaydı indirildi',
            'Screen recording permission denied': 'Ekran kaydı izni reddedildi',
            'Full Screen': 'Tam Ekran',
            'Window': 'Pencere',
            'Browser Tab': 'Tarayıcı Sekmesi',
            'Recording source': 'Kayıt kaynağı',
            'Screen Recording Notice': 'Ekran Kaydı Bildirimi',
            'Screen Recording Notice Message': 'Ekran kaydı için pencere seçtirilmemeli. Tüm ekranın kaydının alınması uygun. Görüntülü görüşme ekranı mutlaka kaydın içinde olmalı.',
            'I Understand': 'Anladım',
            'Please select "Full Screen" or "Entire Screen" when prompted': 'Lütfen istendiğinde "Tam Ekran" veya "Tüm Ekran" seçeneğini seçin',
            'Microphone Muted': 'Mikrofon kapatıldı',
            'Microphone Unmuted': 'Mikrofon açıldı',
            'vcface': 'Yüz (Görüntülü Görüşme)',
            'vcidfront': 'Kimlik Ön Yüz (Görüntülü Görüşme)',
            'vcidback': 'Kimlik Arka Yüz (Görüntülü Görüşme)',
            'vcidclosed': 'Parmakla Kapatma (Görüntülü Görüşme)',
            'vcidfrontphotoblocked': 'Kimlik Ön Yüz Fotoğraf Kapatma',
            'vcidfrontsignatureblocked': 'Kimlik Ön Yüz İmza Kapatma',
            'vcidfronthiddenphotoblocked': ' Kimlik Ön Yüz Gizli Foto Kapatma',
            'vcidfrontstarandcrescentblocked': 'Kimlik Ön Yüz Ay Yıldız Kapatma',
            'vcidbackbarcodeblocked': 'Kimlik Arka Yüz Barkod Kapatma',
            'vcliveness': 'Kimlikli selfie',
            'vcrecord': 'Görüntülü Görüşme Kaydı',
            'Video Call Record': 'Görüntülü Görüşme Kaydı',
            'Video Call Screen Record': 'Görüntülü Görüşme Ekran Kaydı',
            'fullscreenrecord': 'Tam Ekran Kaydı',
            'Refresh': 'Yenile',
            'Table export': 'Tabloyu dışa aktar',
            'Filter': 'Filtrele',
            'Sort': 'Sırala',
            'ID No': 'TCKN',
            'End Call': 'Görüşmeyi Sonlandır',
            'Close Video': 'Kameranı Kapat',
            'Open Video': 'Kameranı Aç',
            'Close Mic': 'Mikrofonunu Kapat',
            'Open Mic': 'Mikrofonunu Aç',
            'Close Customer Mic': 'Müşterinin Mikrofonunu Kapat',
            'Open Customer Mic': 'Müşterinin Mikrofonunu Aç',
            'Flip Customer Camera': 'Müşterinin Kamerasını Değiştir',
            'Take Photo': 'Resim Çek',
            'Agent Availability': 'Durum',
            'Completed Calls': 'Tamamlanan görüşmeler',
            'Awaiting Video Calls': 'Bekleyen görüşmeler',
            'Select Video Call Partner': 'Görüntülü Görüşme Partnerini Seç',
            'ACTIVE': 'Aktif',
            'Active': 'Aktif',
            'PASSIVE': 'Pasif',
            'Passive': 'Pasif',
            'Deactivated': 'Pasif',
            'Out of Office': 'Mesai Dışı',
            'Start Next Call': 'Sıradaki görüşmeyi başlat',
            'Refresh Page': 'Sayfayı Yenile',
            'Choose call status': 'Görüşme durumunu seç',
            'CONFIRMED': 'Görüşme tamamlandı, kullanıcı onaylandı',
            'DECLINED': 'Görüşme tamamlandı, kullanıcı reddedildi',
            'TECHNICAL_FAILURE': 'Teknik bir arıza sebebiyle devam edilemedi',
            'CUSTOMER_FAILURE': 'Müşteri sebebiyle devam edilemedi',
            'WAITING': 'Karar bekleniyor',
            'Edit Video Call Scripts': 'Görüntülü Görüşme Metinlerini Düzenle',
            'Video Call Scripts': 'Görüntülü Görüşme Metinleri',
            'Insert New Step': 'Yeni Adım Ekle',
            'Step No': 'Adım No',
            'Step Detail': 'Adım Adı',
            '_Status': 'Statü',
            'Course': 'Akış',
            'Edit This Step': 'Adımı Düzenle',
            'Edit This Role': 'Rolü Düzenle',
            'Delete This Step': 'Adımı Sil',
            'Select course to add step to': 'Adım eklenecek akışı seç',
            'Add New Step': 'Yeni Adım Ekle',
            'Add New Role': 'Yeni Rol Ekle',
            'Static': 'Statik',
            'Random': 'Rastgele',
            'Random Id Data': 'Rastgele Kimlik Bilgisi',
            'Script Type': 'Script Tipi',
            'Agent Script': 'Agent Scripti',
            'Agent Text': 'Agent Bilgi Metni',
            'Mandatory Action': 'Zorunlu Aksiyon',
            'Face Photo': 'Yüz Fotoğrafı',
            'ID Front Photo': 'Kimlik Ön Yüz Fotoğrafı',
            'ID Back Photo': 'Kimlik Arka Yüz Fotoğrafı',
            'ID Closed Photo': 'Kimlik Kapatma Fotoğrafı',
            'Confirm-Decline': 'Onayla-Reddet',
            'Successful Action': 'Başarılı Aksiyon',
            'Failed Action': 'Başarısız Aksiyon',
            'Next Step': 'Sonraki Adım',
            'See You Again': 'Tekrar Bekleriz',
            'Id Data': 'Kimlik Bilgisi',
            'Add New Option': 'Yeni Seçenek Ekle',
            'Are you sure you want to close without saving?':
                'Kaydetmeden kapatmak istediğinize emin misiniz?',
            'Exit Without Saving': 'Kaydetmeden Çık',
            'Back to Page': 'Sayfaya Dön',
            'A': 'Aktif',
            'D': 'Pasif',
            'kyc-standard-tr': 'KYC - Standart TR',
            'kyc-disabled-tr': 'KYC - Engelli TR',
            'Save Changes': 'Değişiklikleri Kaydet',
            'Incomplete': 'Tamamlanmadı',
            'Completed': 'Tamamlandı',
            'completed': 'Tamamlandı',
            'pending': 'Beklemede',
            'No video call': 'Görüntülü görüşme mevcut değil',
            'Create Demo Link': 'Demo Linki Oluştur',
            'Pending Verifications': 'Kontrol Bekleyen Doğrulamalar',
            'Transaction Time': 'İşlem Zamanı',
            'Checker': 'Checker',
            'Verification Summary': 'Değerlendirme Özeti',
            'Customer': 'Müşteri',
            'insufficient_media': 'Medya eksik',
            'all_media': 'Eksik medya yok',
            'random_question': 'Rastgele Soru',
            'Back to List': 'Listeye Dön',
            'Score': 'Not',
            'Compare': 'Karşılaştır',
            'AWAITING': 'Onay Bekleyen',
            'Pending Documents': 'Kontrol Bekleyen Belgeler',
            'review': 'Onay Bekliyor',
            'Address Document Control': 'Adres Belgesi Kontrolü',
            'The document is valid': 'Belge geçerli',
            'Document': 'Belge',
            'None': 'Yok',
            'Section Checks': 'Bölümler Kontrolü',
            'Verification Code': 'Doğrulama Kodu',
            'Verification Code resent': 'Doğrulama Kodu tekrar gönderildi',
            'Enter 6 characters': '6 karakter giriniz',
            'Time left': 'Kalan süre',
            'The code has expired. Resend.': 'Kodun süresi bitti. Tekrar yolla.',
            'Clear': 'Temizle',
            'Attempted Logins': 'Başarısız Denemeler',
            'login_attempt':
                '{{ date }} tarihinde kullanıcınıza ait başarısız giriş denemesi bulunuyor.',
            'HEAD-HORIZONTAL': ' - Kafa Sağa Sola Oynatma Mimiği Videosu',
            'HEAD-VERTICAL': ' - Kafa Yukarı Aşağı Oynatma Mimiği Videosu',
            'EYE': ' - Göz Mimiği Videosu',
            'MOUTH': ' - Ağız Mimiği Videosu',
            'HH': ' - Kafa Sağa Sola Oynatma Mimiği Videosu',
            'HV': ' - Kafa Yukarı Aşağı Oynatma Mimiği Videosu',
            'E': ' - Göz Mimiği Videosu',
            'M': ' - Ağız Mimiği Videosu',
            'Please wait... Saving photo!': 'Lütfen bekleyiniz... Fotoğraf kaydediliyor!',
            'My Info': 'Bilgilerim',
            'Edit': 'Düzenle',
            'Back Office': 'Arka Ofis',
            'User Management': 'Kullanıcı Yönetimi',
            'Groups': 'Gruplar',
            'Role Groups': 'Rol Grupları',
            'Pending Group Request': 'Bekleyen Grup İsteği',
            'Pending Group Requests': 'Bekleyen Grup',
            'Request Type': 'İstek Türü',
            'Role Group Create': 'Rol Grubu Oluştur',
            'Role Group Update': 'Rol Grubu Güncelle',
            'Role Group Delete': 'Rol Grubu Sil',
            'User Create': 'Kullanıcı Oluştur',
            'User Update': 'Kullanıcı Güncelle',
            'Add New Role Group': 'Yeni Rol Grubu Ekle',
            'Role Group Name': 'Rol Grubu Adı',
            'Roles': 'Roller',
            'Checker Username': 'Kontrol Kullanıcı Adı',
            'Select Request Type': 'İstek Türü Seçin',
            'Select roles': 'Roller Seçin',
            'Select checker': 'Kontrolcü Seçin',
            'Enter role group name': 'Rol grubu adı girin',
            'Enter checker username or email': 'Kontrolcü kullanıcı adı veya e-posta girin',
            'No roles available. Please create role groups first.': 'Mevcut rol yok. Lütfen önce rol grupları oluşturun.',
            'Approve Request': 'İsteği Onayla',
            'Decline Request': 'İsteği Reddet',
            'Do you want to approve the creation of role group "{{name}}" with roles: {{roles}}?': 'Roller: {{roles}} ile "{{name}}" rol grubunun oluşturulmasını onaylamak istiyor musunuz?',
            'Do you want to approve the update of role group "{{name}}" with roles: {{roles}}?': 'Roller: {{roles}} ile "{{name}}" rol grubunun güncellenmesini onaylamak istiyor musunuz?',
            'Do you want to approve the deletion of role group "{{name}}"?': '"{{name}}" rol grubunun silinmesini onaylamak istiyor musunuz?',
            'Do you want to approve the creation of user "{{user}}"?': '"{{user}}" kullanıcısının oluşturulmasını onaylamak istiyor musunuz?',
            'Do you want to approve the update of user "{{user}}"?': '"{{user}}" kullanıcısının güncellenmesini onaylamak istiyor musunuz?',
            'Do you want to approve this request?': 'Bu isteği onaylamak istiyor musunuz?',
            'Do you want to decline the creation of role group "{{name}}"?': '"{{name}}" rol grubunun oluşturulmasını reddetmek istiyor musunuz?',
            'Do you want to decline the update of role group "{{name}}"?': '"{{name}}" rol grubunun güncellenmesini reddetmek istiyor musunuz?',
            'Do you want to decline the deletion of role group "{{name}}"?': '"{{name}}" rol grubunun silinmesini reddetmek istiyor musunuz?',
            'Do you want to decline the creation of user "{{user}}"?': '"{{user}}" kullanıcısının oluşturulmasını reddetmek istiyor musunuz?',
            'Do you want to decline the update of user "{{user}}"?': '"{{user}}" kullanıcısının güncellenmesini reddetmek istiyor musunuz?',
            'Do you want to decline this request?': 'Bu isteği reddetmek istiyor musunuz?',
            'Role group approved successfully': 'Rol grubu başarıyla onaylandı',
            'Request approved successfully': 'İstek başarıyla onaylandı',
            'Role group declined successfully': 'Rol grubu başarıyla reddedildi',
            'Request declined successfully': 'İstek başarıyla reddedildi',
            'Role group creation request sent successfully': 'Rol grubu oluşturma isteği başarıyla gönderildi',
            'Couldn\'t fetch role groups': 'Rol grupları alınamadı',
            'Couldn\'t fetch pending group requests': 'Bekleyen grup istekleri alınamadı',
            'Couldn\'t approve request': 'İstek onaylanamadı',
            'Couldn\'t decline request': 'İstek reddedilemedi',
            'Couldn\'t create role group': 'Rol grubu oluşturulamadı',
            'Please enter role group name': 'Lütfen rol grubu adı girin',
            'Please select at least one role': 'Lütfen en az bir rol seçin',
            'Please enter checker username': 'Lütfen kontrolcü kullanıcı adı girin',
            'No roles': 'Rol yok',
            'Maker': 'Oluşturan',
            'Roles / Role Group': 'Roller / Rol Grubu',
            'Role Group ID': 'Rol Grubu ID',
            'Only users with checker or role-checker role can list role groups': 'Sadece checker veya role-checker rolüne sahip kullanıcılar rol gruplarını listeleyebilir',
            'Edit Role Group': 'Rol Grubunu Düzenle',
            'Delete Role Group': 'Rol Grubunu Sil',
            'Update Role Group': 'Rol Grubunu Güncelle',
            'Role group update request sent successfully': 'Rol grubu güncelleme isteği başarıyla gönderildi',
            'Role group deletion request sent successfully': 'Rol grubu silme isteği başarıyla gönderildi',
            'Cannot delete role group with assigned users. User count: {{count}}': 'Atanmış kullanıcıları olan rol grubu silinemez. Kullanıcı sayısı: {{count}}',
            'Warning: This role group has {{count}} assigned user(s).': 'Uyarı: Bu rol grubunun {{count}} atanmış kullanıcısı var.',
            'Do you want to delete role group "{{name}}"?': '"{{name}}" rol grubunu silmek istiyor musunuz?',
            'Couldn\'t update role group': 'Rol grubu güncellenemedi',
            'Couldn\'t delete role group': 'Rol grubu silinemedi',
            'Group': 'Grup',
            'Group Name': 'Grup Adı',
            'Create Group': 'Grup Oluştur',
            'Edit Group': 'Grup Düzenle',
            'Group List': 'Grup Listesi',
            'Permissions': 'Yetkiler',
            'Select Permissions': 'Yetkileri Seç',
            'Save': 'Kaydet',
            'Cancel': 'İptal',
            'Delete': 'Sil',
            'Edit': 'Düzenle',
            'No groups found': 'Grup bulunamadı',
            'Group created successfully': 'Grup başarıyla oluşturuldu',
            'Group updated successfully': 'Grup başarıyla güncellendi',
            'Group deleted successfully': 'Grup başarıyla silindi',
            'Are you sure you want to delete this group?': 'Bu grubu silmek istediğinizden emin misiniz?',
            'Selected': 'Seçilen',
            'is required': 'zorunludur',
            'No permissions available': 'Yetki bulunamadı',
            'Please select at least one permission': 'Lütfen en az bir yetki seçin',
            'Video Call Management': 'Görüntülü Görüşme Yönetimi',
            'Go to Web SDK Demo': 'Web SDK Demoya Git',
            'Invalid': 'Geçersiz',
            'Update Settings': 'Bilgilerimi Güncelle',
            'Your session has expired': 'Oturumunuz sonlandırılmıştır.',
            'Role Management': 'Rol Yönetimi',
            'Role Name': 'Rol adı',
            'Acceptance Threshold': 'Kabul Eşiği',
            'Security Threshold': 'Güvenlik Eşiği',
            'Control Name': 'Kontrol Adı',
            'No Role': 'Ek rol yok',
            'Thresholds': 'Eşik Değerleri',
            'Remove User': 'Kullanıcıyı Sil',
            'The user you selected will be removed. Do you want to continue?':
                'Seçtiğiniz kullanıcı kaldırılacaktır. Devam etmek istiyor musun?',
            'Users To Be Deleted': 'Silinecek Kullanıcılar',
            'Users To Be Cancelled': 'İptal Edilecek Kullanıcılar',
            'Users To Be Updated': 'Güncellenecek Kullanıcılar',
            'Do you want to continue?': 'Devam etmek istiyor musun?',
            'Confirmation': 'Onayla',
            'Request Sent': 'Talep Gönderildi',
            'Pending For Deletion': 'Silinmek İçin Bekliyor',
            'Pending For Cancellation': 'Passifleştirilmek İçin Bekliyor',
            'Pending For Update': 'Güncellenmek İçin Bekliyor',
            'new_id': 'Yeni Kimlik Ön Yüz',
            'new_id_back': 'Yeni Kimlik Arka Yüz',
            'old_id': 'Eski Kimlik Ön Yüz',
            'old_id_back': 'Eski Kimlik Arka Yüz',
            'new_driver': 'Yeni Sürücü Belgesi Ön Yüz',
            'new_driver_back': 'Yeni Sürücü Belgesi Arka Yüz',
            'old_driver': 'Eski Sürücü Belgesi Ön Yüz',
            'old_driver_back': 'Eski Sürücü Belgesi Arka Yüz',
            'address_confirmation_document': 'Adres Doğrulama Belgesi',
            'signature_document': 'İmza',
            'Job': 'Meslek',
            'External System Id': 'Harici Sistem Kodu',
            'External System ID': 'Harici Sistem ID',
            'Please fill in the required fields marked with *': 'Lütfen * ile işaretli zorunlu alanları doldurun',
            'Address': 'Adres',
            'External Customers': 'Harici Müşteriler',
            'Add Customer': 'Müşteri Ekle',
            'Customer added successfully': 'Müşteri başarıyla eklendi',
            'Failed to add customer': 'Müşteri eklenemedi',
            'Select Status': 'Durum Seçin',
            'Inactive': 'Pasif',
            'Pending': 'Beklemede',
            'Note': 'Not',
            'Email': 'E-posta',
            'ID Number': 'Kimlik Numarası',
            'Add File': 'Dosya Ekle',
            'Mime Type': 'Mime Tipi',
            'Click to select a file or paste an image': 'Dosya seçmek için tıklayın veya resim yapıştırın',
            'Select File': 'Dosya Seç',
            'Supported formats: Images and PDF': 'Desteklenen formatlar: Resimler ve PDF',
            'File': 'Dosya',
            'Remove File': 'Dosyayı Kaldır',
            'File Added Successfully': 'Dosya Başarıyla Eklendi',
            'File uploaded successfully': 'Dosya başarıyla yüklendi',
            'Would you like to add another file or complete the process?': 'Başka bir dosya eklemek ister misiniz yoksa işlemi tamamlamak mı istersiniz?',
            'Add Another File': 'Başka Dosya Ekle',
            'Complete': 'Tamamla',
            'TR New ID': 'Yeni Kimlik',
            'TR Old ID': 'Eski Kimlik',
            'Passport': 'Pasaport',
            'TR Driving Licence': 'Sürücü Belgesi',
            'TR Old Driving Licence': 'Eski Sürücü Belgesi',
            'Address Confirmation Document': 'Adres Doğrulama Belgesi',
            'Signature': 'İmza',
            'Other': 'Diğer',
            'Edit Customer': 'Müşteri Düzenle',
            'Update Customer': 'Müşteriyi Güncelle',
            'Customer updated successfully': 'Müşteri başarıyla güncellendi',
            'Failed to update customer': 'Müşteri güncellenemedi',
            'Documents': 'Dokümanlar',
            'files': 'dosya',
            'Use arrow keys or click arrows to navigate': 'Ok tuşları veya oklara tıklayarak gezin',
            'browser': 'Tarayıcı',
            'mobile': 'Mobil',
            'Update User': 'Kullanıcı Güncelle',
            'answeredCallsCount': 'Cevaplanan Çağrı',
            'answeredCallsRatio': 'Cevaplanma Oranı (%)',
            'answeredCallsTotalWaitingTime': 'Cevaplanan Çağrılarda Toplam Bekleme Süresi',
            'avgAnsweredCallsWaitingTime': 'Cevaplanan Çağrılarda Ortalama Bekleme Süresi',
            'avgMeetingTime': 'Ortalama Görüşme Süresi',
            'avgWaitingTime': 'Ortalama Bekleme Süresi',
            'maxWaitingTime': 'Maks. Bekleme Süresi',
            'totalCallsCount': 'Toplam Çağrı',
            'totalMeetingTime': 'Toplam Görüşme Süresi',
            'totalWaitingTime': 'Toplam Bekleme Süresi',
            'Date Range': 'Tarih aralığı',
            'Queue Based Call History Report': 'Kuyruk Bazında Çağrı Raporu',
            'Clear Filters': 'Temizle',
            'Create Report': 'Rapor Oluştur',
            'inbound.answeredCalls': 'Cevaplanan Çağrı Sayısı',
            'inbound.rejectedCalls': 'Reddedilen Çağrı Sayısı',
            'inbound.totalMeetingTime': 'Toplam Görüşme Süresi',
            'inbound.avgMeetingTime': 'Ortalama Görüşme Süresi',
            'inbound.totalWaitingTime': 'Toplam Çağrı Cevaplama Süresi',
            'inbound.avgWaitingTime': 'Ortalama Çağrı Cevaplama Süresi',
            'totalActiveTime': 'Toplam Aktif Süresi',
            'totalPassiveTime': 'Toplam Pasif Süresi',
            'hostFullName': 'Uzman',
            'Call Statistics Based On Agent': 'Uzman Bazında Çağrı İstatistikleri',
            'call_no': 'Çağrı No',
            'queueInfo.queueName': 'Kuyruk Adı',
            'host.fullname': 'Çağrıyı karşılayan kişi',
            'customer.fullName': 'Müşteri',
            'queueEntryDate': 'Kuyruğa Giriş Zamanı',
            'waitingTime': 'Bekleme Süresi',
            'meetingTime': 'Görüşme süresi',
            'appointmentId': 'Randevu No',
            '$appointmentId': 'Durum',
            'Queue Based Call Detail': 'Kuyruk Bazında Gelen Çağrı Detayı',
            'availableAgents': 'Müsait temsilciler',
            'host.fullName': 'Çağrıyı karşılayan kişi',
            'queueName': 'Kuyruk Adı',
            'customerFullname': 'Müşteri',
            'callReceivedTime': 'Temsilciye Ulaşma zamanı',
            'meetingCompletedDate': 'Görüşme Bitiş Zamanı',
            'response': 'Durum',
            'candidateQueueMeetingInfoId': 'Çağrı No',
            'Call Details Based On Agent': 'Uzman Bazında Gelen Çağrı Detayı',
            'Video Call Reports': 'Görüntülü Görüşme Raporları',
            'Transaction re-opening rate of the same TR ID number':
                "Aynı TCKN'nin tekrar transaction açma oranı",
            'Retry #': 'Tekrar sayısı',
            'Customer acquisition rate': 'Müşteri olma oranı',
            'Number of TR ID numbers that initiate KYC': 'KYC başlatan TCKN sayısı',
            'Number of TR ID numbers that became customers': 'Müşteri olan TCKN sayısı',
            'Customer Loss': 'Müşteri kaybı',
            'Step failure rate': 'Başarısız adım oranı',
            'Channel Type Distribution': 'Akış tipi dağılımı',
            'With NFC': "NFC'li",
            'Without NFC': "NFC'siz",
            'General statistics': 'Genel İSTATİSTİKLER',
            'Controls statistics': 'Kontrol İSTATİSTİKLERİ',
            'Step statistics': 'Adım İSTATİSTİKLERİ',
            'Today': 'Bugün',
            'Last 7 Days': 'Son 7 Gün',
            'Last 30 Days': 'Son 30 Gün',
            'Completed all steps': 'Tüm adımları tamamlayanlar',
            'Did not proceed beyond the liveness step': 'Canlılık adımından sonrasına geçemeyenler',
            'Did not proceed beyond the NFC step': 'NFC adımından sonrasına geçemeyenler',
            'Did not proceed beyond the hologram step': 'Hologram adımından sonrasına geçemeyenler',
            'Did not proceed beyond the card front face capture step':
                'Ön Yüz kart yakalama adımından sonrasına geçemeyenler',
            'Did not proceed beyond the card back face capture step':
                'Arka Yüz kart yakalama adımından sonrasına geçemeyenler',
            'Hourly / Last 24 Hours': 'Saatlik / Son 24 saat',
            'Weekly / 7 Days': 'Haftalık / Son 7 gün',
            'Monthly / Last 31 Days': 'Aylık / Son 31 gün',
            'Reports': 'Raporlar',
            'Verification Reports': 'Doğrulama Raporları',
            'Mimic \\ Retry #': 'Mimik \\ Tekrar Sayısı',
            'Controls \\ Score range': 'Kontroller \\ Skor Aralığı',
            'Certificate Controls': 'Sertifika Kontrolleri',
            'Scores greater than specified value pass':
                'Belirtilen değerden daha yüksek skorlar geçer',
            'Scores less than specified value pass': 'Belirtilen değerden daha düşük skorlar geçer',
            'No device info': 'Cihaz bilgisi yok',
            'No process info': 'İşlem bilgisi yok',
            'Yesterday': 'Dün',
            'SCREENATTACKBACK': 'Ekran Saldırısı (Arka Yüz)',
            'MRZCOMPOSITECHECKSUM': 'Bileşim Kontrol Basamağı',
            'MRZCOMPOSITECHECKSUMVALID': 'Bileşim Kontrol Basamağı Doğruluğu',
            'FACEPHOTOEXISTENCE': 'Fotoğraf Bulunma Kontrolü',
            'CHIPDETECTION': 'Çip Bulunma Kontrolü',
            'Label': 'Açıklama',
            'Field': 'Alan',
            'Previous Value': 'Eski Değer',
            'New Value': 'Yeni Değer',
            'Old': 'Eski',
            'New': 'Yeni',
            'Update': 'Güncelle',
            'View': 'Görüntüle',
            'Date of Latest Transaction Processed for Reporting':
                'Raporlama İçin İşlenen Son İşlem Tarihi',
            'Selected verifications exceed 1 week, documents cannot be exported.':
                'Seçilen doğrulamaların tarih aralığı 1 haftayı aşıyor, dokümanlar dışa aktarılamaz.',
            'Start Reporting Service': 'Raporlama Servisini Başlat',
            'Reporting Service': 'Raporlama Servisi',
            'Report Settings': 'Rapor Ayarları',
            'Threshold Warning': 'Eşik Uyarısı',
            'This threshold will be reflected in reports but you will not be able to see it on screen. Do you want to continue?': 'Bu eşik raporlara yansıyacak ancak ekranda göremeyeceksiniz. Devam etmek istiyor musunuz?',
            'Threshold will be reflected in reports but not visible on screen': 'Eşik raporlara yansıyacak ancak ekranda görünmeyecek',
            'Update Warning': 'Güncelleme Uyarısı',
            'If you make an update, the control will be activated': 'Güncelleme yaptığınız taktirde kontrol etkin olacaktır',
            'Are you sure you want to delete the user?':
                'Kullanıcıyı silmek istediğinizden emin misiniz?',
            'There is no need for the document to be checked. The document will be removed from the list.':
                'Dokümanın incelenmesine gerek bulunmamaktadır. Doküman, listeden çıkarılacaktır.',
            'Outdated Document': 'Geçersiz Doküman',
            'Password should be at least 9 characters and include lower case upper case letter number and special character.':
                'Şifreniz en az 9 karakterden oluşmalı ve en az bir büyük harf, küçük harf, rakam ve özel karakter içermeli.',
            'Current Threshold': 'Mevcut Eşik',
            'Passed': 'Geçti',
            'Failed': 'Başarısız',
            'Passed Tid': 'Geçen Tid',
            'Failed Tid': 'Başarısız Tid',
            'Hand': 'Kimliği Parmakla Kapatma',
            'Card-Hold-Liveliness': 'Kartı Tutarak Canlılık',
            'HANDLANDMARKTYPEMATCHTHUMBRIGHTDOWN': 'Parmakla Kapatmada Kimlik Tipi Kontrolü',
            'HANDLANDMARKSCORE THUMBRIGHTDOWN':
                'Kimliğin Sağ Alt Köşesini Parmakla Kapatma Kontrolü',
            'HANDLANDMARKTYPEMATCH THUMBRIGHTUP': 'Parmakla Kapatmada Kimlik Tipi Kontrolü',
            'HANDLANDMARKSCORE THUMBRIGHTUP': 'Kimliğin Sağ Üst Köşesini Parmakla Kapatma Kontrolü',
            'HANDLANDMARKTYPEMATCH THUMBLEFTDOWN': 'Parmakla Kapatmada Kimlik Tipi Kontrolü',
            'HANDLANDMARKSCORE THUMBLEFTDOWN':
                'Kimliğin Sol Alt Köşesini Parmakla Kapatma Kontrolü',
            'HANDLANDMARKTYPEMATCH THUMBLEFTUP': 'Parmakla Kapatmada Kimlik Tipi Kontrolü',
            'HANDLANDMARKSCORE THUMBLEFTUP': 'Kimliğin Sol Üst Köşesini Parmakla Kapatma Kontrolü',
            'LWICONLYFRONCARDTYPESIMILARITY': 'Kartlı Canlılıkta Kart Tipi Kontrolü',
            'LWICONLYFRONTFACESIMILARITY (A-D)': 'Kartlı Canlılıkta Yüz Benzerlik Puanı',
            'LWICONLYFRONTOCRSIMILARITY': 'Kartlı Canlılıkta OCR Benzerlik Kontrolü',
            'LWICLIVENESSAI': 'Kartlı Canlılıkta Yapay Zeka Puanı',
            'LWICSELFIEFIRSTIDFACESIMILARITY(A-C)':
                'Kartlı Canlılıkta Kart Üstündeki Yüz Benzerliği',
            'PHOTOSHOPCONTROLBACK': 'Photoshop Kontrolü Arka Yüz',
            'PHOTOSHOPCONTROL': 'Photoshop Kontrolü Ön Yüz',
            'APPROVAL': 'Onay Metni Kontrolü',
            'Face-Match': 'Yüz Karşılaştırma',
            'SERIALNUMBER': 'Seri Numarası Kontrolü',
            'THUMBRIGHTUP': 'Parmakla Kapatma Kontrolü',
            'THUMBLEFTUP': 'Parmakla Kapatma Kontrolü',
            'THUMBLEFTDOWN': 'Parmakla Kapatma Kontrolü',
            'THUMBRIGHTDOWN': 'Parmakla Kapatma Kontrolü',
            'THUMBRIGHTLEFTUP': 'Parmakla Kapatma Kontrolü',
            'THUMBRIGHTLEFTDOWN': 'Parmakla Kapatma Kontrolü',
            // Media type translations
            'newidfront': 'Kimlik Ön Yüz',
            'secondaryidfile': 'Kimlik Arka Yüz',
            'newidfront_frame': 'Kimlik Ön Yüz Kırpılmamış',
            'secondaryidfile_frame': 'Kimlik Arka Yüz Kırpılmamış',
            'newidfront_': 'Kimlik Ön Yüz Kırpılmamış',
            'secondaryidfile_': 'Kimlik Arka Yüz Kırpılmamış',
            'handlandmark_THUMBRIGHTDOWN': 'Kimliği Parmakla Kapatma',
            'handlandmark_THUMBRIGHTUP': 'Kimliği Parmakla Kapatma',
            'handlandmark_THUMBLEFTDOWN': 'Kimliği Parmakla Kapatma',
            'handlandmark_THUMBLEFTUP': 'Kimliği Parmakla Kapatma',
            'hologram': 'Hologram Videosu',
            'nfcbiometricpicture': 'NFC Portesi',
            'livenessonlyface': 'Kimlikli Selfie',
            'face': 'Canlılık Videosu',
            'livenessframe': 'Canlılık Yüz Fotoğrafı',
            'facewithvoice_SERIALNUMBER': 'Seri No Doğrulama Videosu',
            'facewithvoice_APPROVAL': 'Sesli Onay Videosu',
            'newidface': 'Kimlik Portesi',
            'signature': 'İmza',
            'hiddenphoto': 'Gizli Foto',
            'livenesswithidfront': 'Kimlikli Selfie Ön Yüz',
            'livenesswithidfrontandface': 'Kimlikli Selfie Ön Yüz',
            'livenesswithidback': 'Kimlikli Selfie Arka Yüz',
            'livenesswithidbackandface': 'Kimlikli Selfie Arka Yüz',
            'facewithvoiceaudio_SERIALNUMBER': 'Seri No Doğrulama Videosu Sesi',
            'livenesswithvoiceframe_SERIALNUMBER': 'Seri No Doğrulama Videosu Frame',
            'livenesswithvoiceframe_APPROVAL': 'Sesli Onay Videosu Frame',
            'facewithvoiceaudio_APPROVAL': 'Sesli Onay Videosu Sesi',
            'LWICONLYFRONTFACESIMILARITY': 'Kartlı Canlılıkta Kimlikler Arası Yüz Benzerlik Puanı',
            'LWICSELFIEFIRSTIDFACESIMILARITY': 'Kartlı Canlılıkta Yüz Benzerlik Puanı',
            'Voice': 'Ses Kontrolü Adımları',
            'FWVLIVENESSAI SERIALNUMBER': 'Seri Numarası Kontrolünde Yapay Zeka Puanı',
            'FWVLIVENESSAI APPROVAL': 'Onay Metni Kontrolünde Toplam Canlılık Skoru',
            'FWVLIVENESSGESTURE SERIALNUMBER': 'Seri Numarası Kontrolünde Mimik Algılama',
            'FWVLIVENESSFACECONSAVG SERIALNUMBER':
                'Seri Numarası Kontrolünde Ortalama Yüz Benzerlik Puanı',
            'FWVLIVENESSFACECONSPER SERIALNUMBER': 'Seri Numarası Kontrolünde Geçerli Yüz Oranı',
            'FWVFACE SERIALNUMBER': 'Seri Numarası Kontrolünde Yüz Benzerlik Puanı',
            'FWVAGE SERIALNUMBER': 'Seri Numarası Kontrolünde Yaş Tahmini',
            'FWVGENDER SERIALNUMBER': 'Seri Numarası Kontrolünde Cinsiyet Tahmini',
            'FWVSPEECHMATCH SERIALNUMBER': 'Seri Numarası Kontrolünde Söylem Doğruluk Kontrolü',
            'FWVLIVENESS APPROVAL': 'Onay Metni Kontrolünde Toplam Canlılık Skoru',
            'FWVLIVENESSGESTURE APPROVAL': 'Onay Metni Kontrolünde Mimik Algılama',
            'FWVLIVENESSFACECONSAVG APPROVAL':
                'Onay Metni Kontrolünde Ortalama Yüz Benzerlik Puanı',
            'FWVLIVENESSFACECONSPER APPROVAL': 'Onay Metni Kontrolünde Geçerli Yüz Oranı',
            'FWVFACE APPROVAL': 'Onay Metni Kontrolünde Yüz Benzerlik Puanı',
            'FWVAGE APPROVAL': 'Onay Metni Kontrolünde Yaş Tahmini',
            'FWVGENDER APPROVAL': 'Onay Metni Kontrolünde Cinsiyet Tahmini',
            'FWVSPEECHMATCH APPROVAL': 'Onay Metni Kontrolünde Söylem Doğruluk Kontrolü',
            'FWVSPEECHCONSISTENCY APPROVAL': 'Onay Metni Kontrolünde Ses Uyumluluk Kontrolü',
            'SECURITYOBJECTVERIFICATION': 'Güvenlik Öğeleri Yorumu',
            'External Id': 'Sicil No',
            'HANDLANDMARKTYPEMATCH THUMBRIGHTDOWN': 'Parmakla Kapatmada Kimlik Tipi Kontrolü',
            'Export completed successfully': 'Dışa aktarma başarıyla tamamlandı',
            "Couldn't export data": 'Veri dışa aktarılamadı',
            'device_controls': 'Cihaz Kontrolleri',
            'identity': 'Kimlik',
            'liveness': 'Canlılık',
            'nfc': 'NFC',
            'id_front_face': 'Kimlik Ön Yüz',
            'id_back_face': 'Kimlik Arka Yüz',
            'liveness_passive_photo': 'Canlılık Pasif Fotoğraf',
            'liveness_passive_video': 'Canlılık Pasif Video',
            'liveness_active_eye_blink': 'Canlılık Aktif Göz Kırpma',
            'liveness_active_left_right': 'Canlılık Aktif Sağ Sol',
            'liveness_active_up_down': 'Canlılık Aktif Yukarı Aşağı',
            'id_selection': 'Kimlik Seçimi',
            'error': 'Hata',
            'step_started': 'Adım Başlatma',
            'detection': 'Tespit',
            'step_completed': 'Adım Tamamlama',
            'insufficient_light_detected': 'Yeterli ışık tespit edilemedi',
            'insufficient_connection_speed': 'Bağlantı hızı yetersiz',
            'insufficient_camera': 'Yeterli kamera yok',
            'no_camera_flash': 'Kamera ışığı yok',
            'different_id_type_shown': 'İstenenden farklı bir kimlik türü gösterildi',
            'other_side_of_id_shown': 'Kimliğin diğer yüzü gösterildi',
            'id_held_too_far': 'Kimlik çok uzakta tutuldu',
            'id_held_too_close': 'Kimlik çok yakında tutuldu',
            'image_not_clear': 'Görüntü net değil',
            'multiple_faces_detected': 'Birden fazla yüz tespit edildi',
            'no_face_detected': 'Yüz tespit edilemedi',
            'face_held_too_close': 'Yüz çok yakında tutuldu',
            'face_held_too_far': 'Yüz çok uzakta tutuldı',
            'connection_disconnected': 'Bağlantı koparıldı',
            'mrz_chip_data_mismatch': 'MRZ ve çip verisi uyumsuz',
            'card_not_approached': 'Kart yaklaştırılmadı',
            'device_control_step_started': 'Cihaz kontrol adımı başlatıldı',
            'id_front_face_step_started': 'Kimlik ön yüz adımı başlatıldı',
            'id_back_face_step_started': 'Kimlik arka yüz adımı başlatıldı',
            'nfc_step_started': 'NFC adımı başlatıldı',
            'hologram_step_started': 'Hologram adımı başlatıldı',
            'liveness_passive_photo_step_started': 'Canlılık Pasif Fotoğraf adımı başlatıldı',
            'liveness_passive_video_step_started': 'Canlılık Pasif Video adımı başlatıldı',
            'liveness_active_eye_blink_step_started': 'Canlılık Aktif Göz Kırpma adımı başlatıldı',
            'liveness_active_left_right_step_started': 'Canlılık Aktif Sağ Sol adımı başlatıldı',
            'liveness_active_up_down_step_started': 'Canlılık Aktif Yukarı Aşağı adımı başlatıldı',
            'sufficient_light_available': 'Yeterli ışık var',
            'connection_speed_appropriate': 'Bağlantı hızı uygun',
            'sufficient_camera_available': 'Yeterli kamera var',
            'camera_flash_available': 'Kamera ışığı var',
            'id_selection_made_new_id': 'Kimlik seçimi yapıldı - TCKK',
            'id_selection_made_driver': 'Kimlik seçimi yapıldı - Ehliyet',
            'id_selection_made_passport': 'Kimlik seçimi yapıldı - Pasaport',
            'id_selection_made_blue_card': 'Kimlik seçimi yapıldı - Mavi Kart',
            'id_selection_made_foreign_id': 'Kimlik seçimi yapıldı - Yabancı Kimlik',
            'device_controls_step_completed': 'Cihaz kontrolleri adımı tamamlandı',
            'id_front_face_step_completed': 'Kimlik Ön Yüz adımı tamamlandı',
            'id_back_face_step_completed': 'Kimlik Arka Yüz adımı tamamlandı',
            'nfc_step_completed': 'NFC adımı tamamlandı',
            'hologram_step_completed': 'Hologram adımı tamamlandı',
            'liveness_passive_video_step_completed': 'Canlılık Pasif Video adımı tamamlandı',
            'liveness_passive_photo_step_completed': 'Canlılık Pasif Fotoğraf adımı tamamlandı',
            'liveness_active_eye_blink_step_completed': 'Canlılık Aktif Göz Kırpma adımı tamamlandı',
            'liveness_active_left_right_step_completed': 'Canlılık Aktif Sağ Sol adımı tamamlandı',
            'liveness_active_up_down_step_completed': 'Canlılık Aktif Yukarı Aşağı adımı tamamlandı',
            'Process Step': 'İşlem Adımı',
            'Record Description': 'Kayıt Açıklaması',
            'Record Type': 'Kayıt Türü',
            'Unknown': 'Bilinmeyen',
            'No description found': 'Açıklama bulunamadı',
            'Info': 'Bilgi',
            'Include Transactions Without...': 'İşlemleri Dahil Et',
            'Hide transactions where media and data are empty': 'Medya ve verisi boş olan işlemleri gösterme',
            'Show transactions with data but no media': 'Verisi olan ama medyası olmayan işlemleri göster',
            'Include transactions where media and data are empty': 'Medya ve verisi boş olan işlemleri dahil et',
            'Video Call Status': 'Video Çağrı Durumu',
            'Total Rows': 'Toplam Satır',
            'Unique Transactions': 'Benzersiz İşlemler',
            'Unique Identities': 'Benzersiz Kimlikler',
            'Status Breakdown': 'Durum Dağılımı',
            'Status with Details': 'Detaylı Durum',
            'No data available': 'Veri mevcut değil',
            'Select Agent': 'Agent Seçin',
            'Recording': 'Kayıt',
            'Recording Stopped': 'Kayıt Durduruldu',
            'DECLINED_SCREEN_SHARE': 'Ekran Paylaşımı Reddedildi',
            'Screen recording permission denied': 'Ekran kaydı izni reddedildi',
            'The existing user in the call has been successfully replaced with a new user.' : 'Mevcut kullanıcı çağrıda başarıyla yeni kullanıcı ile değiştirildi.',
            'Video Call Agents': 'Video Çağrı Kullanıcıları',
            'Error occurred while answering the call. Please try again. Possible reasons: Call not available, Queue not available, etc.' : 'Çağrı yanıtlanırken bir hata oluştu. Lütfen tekrar deneyin. Nedenleri: Çağrı mevcut değil, Kuyruk mevcut değil, vb.',
            'List All Archive Media': 'Tüm Arşiv Medyalarını Listele',
            'Logs': 'Loglar',
            'Backend Logs': 'Backend Logları',
            'OK': 'Tamam',
            'Active video call session': 'Aktif Görüntülü Görüşme Oturumu',
            'Another video call session is already active in a different tab. You cannot start a new video call from this screen. Please return to the existing session tab.':
                'Başka bir sekmede aktif bir görüntülü görüşme oturumu açık. Bu ekrandan yeni bir görüntülü görüşme başlatamazsınız. Lütfen mevcut görüşme sekmesine geri dönünüz.',
            'Package Usage': 'Paket Kullanımı',
            'Total Package': 'Toplam Paket',
            'Used': 'Kullanılan',
            'Remaining': 'Kalan',
            'Milestone Date': 'Dönüm Tarihi',
            'Do you want to confirm to deactivate user {{user}}?':
                '{{user}} kullanıcısını pasife almayı onaylıyor musunuz?',
            'Do you want to decline to deactivate user {{user}}?':
                '{{user}} kullanıcısını pasife alma talebini reddetmek mi istiyorsunuz?',
            'Do you want to confirm to delete user {{user}}?':
                '{{user}} kullanıcısını silme talebini onyalamak istediğinizden emin misiniz?',
            'Do you want to decline to delete user {{user}}?':
                '{{user}} kullanıcısının silme talebini reddetmek istediğinizden emin misiniz?',
            'Your password has been expired. Please reset your password first':
                'Şifrenizin süresi dolmuştur. Lütfen önce şifrenizi sıfırlayınız',
            'Set New Password': 'Yeni Şifre Belirle',
            'Video Call Agents': 'Video Çağrı Ajanları',
            'Agent ID': 'Ajan ID',
            'Queue Code': 'Kuyruk Kodu',
            'Provider': 'Sağlayıcı',
            'Edit Agent': 'Ajanı Düzenle',
            'Agent updated successfully': 'Ajan başarıyla güncellendi',
            'Couldn\'t update agent': 'Ajan güncellenemedi',
            'Couldn\'t remove user from previous queue': 'Kullanıcı önceki kuyruktan kaldırılamadı',
            'Couldn\'t get external user ID from response': 'Yanıttan harici kullanıcı ID\'si alınamadı',
            'Username will be created as {{username}} on provider side': 'Sağlayıcı tarafında kullanıcı adınız {{username}} olarak oluşturulacaktır.',
            'Update': 'Güncelle',
        },
    },
    en: {
        translation: {
            'metaData': 'Meta Data',
            'vcrecord': 'Video Call Record',
            'Video Call Record': 'Video Call Record',
            'Video Call Screen Record': 'Video Call Screen Record',
            'fullscreenrecord': 'Full Screen Record',
            'List All Archive Media': 'List All Archive Media',
            'Logs': 'Logs',
            'Backend Logs': 'Backend Logs',
            'OK': 'OK',
            'Active video call session': 'Active Video Call Session',
            'Another video call session is already active in a different tab. You cannot start a new video call from this screen. Please return to the existing session tab.':
                'Another video call session is already active in a different tab. You cannot start a new video call from this screen. Please return to the existing session tab.',
            'Package Usage': 'Package Usage',
            'Total Package': 'Total Package',
            'Used': 'Used',
            'Remaining': 'Remaining',
            'Milestone Date': 'Milestone Date',
            'GENDERSIMILARITY': 'Gender Similarity',
            'SCREENATTACKFRONT': 'Screen Attack',
            'FRAMESCREENATTACKFRONT': 'Frame-based Screen Attack Detection',
            'FRAMESCREENATTACKBACK': 'Frame-based Screen Attack Detection Back Face',
            'TAMPERDETECTION': 'Tamper Detection',
            'TAMPERDETECTIONBACK': 'Tamper Detection Back Face',
            'AGESIMILARITY': 'Age Smilarity',
            'LIVENESSGENDERSIMILARITY': 'Liveness Gender Similarity',
            'LIVENESSAGESIMILARITY': 'Liveness Age Similarity',
            'Do you want to decline to deactivate user {{user}}?':
                'Do you want to decline to deactivate user {{user}}?',
            'Do you want to confirm to deactivate user {{user}}?':
                'Do you want to confirm to deactivate user {{user}}?',
            'transactionType': 'Transaction Type',
            'idType': 'ID Type',
            'handLandmarks': 'Hand Landmark',
            'Close': 'Close',
            '_newidfront': 'TR New ID',
            '_hiddenphoto': 'Hidden Photo',
            'prove_result': 'Prove Results',
            'user_details': 'User Details',
            'id_number': 'Id Number',
            'Your session timed out. Please re-login': 'Your session timed out. Please re-login',
            'MRZEXPDATECHECKSUMVALID': 'Expiry Date Check Digit Validity',
            'MRZBIRTHDATECHECKSUMVALID': 'Date of Birth Check Digit Validity',
            'MRZDOCNUMCHECKSUMVALID': 'Document Number Check Digit Validity',
            'HOLOGRAMSERIALSIMILARITY': 'Serial Number Similarity Score via Hologram',
            'HOLOGRAMBDATESIMILARITY': 'Birth Date Similarity Score via Hologram',
            'HOLOGRAMEDATESIMILARITY': 'Expiry Date Similarity Score via Hologram',
            'AGE': 'Age Prediction via ID Photo',
            'GENDER': 'Gender Prediction via ID Photo',
            'LIVENESSAGE': 'Age Prediction via Liveness',
            'LIVENESSFACEBLACKLISTSCORE': 'Similarity to Blacklisted Faces via Liveness',
            'LIVENESSGENDER': 'Gender Prediction via Liveness',
            'HOLOGRAMIDSIMILARITY': 'ID No Similarity Score via Hologram',
            'PHOTOCHEAT': 'ID Photo Verification',
            'FACESIMILARITY': 'Face Similarity Score',
            'Face-Match': 'Face Compare',
            'HOLOGRAM': 'Hologram Detection',
            'HOLOGRAMFACE': 'Face Similarity Score via Hologram',
            'FACELIVENESSFACECONSPER': 'Valid Face Ratio at Liveness',
            'FACELIVENESSFACECONSAVG': 'Average Face Similarity Score at Liveness',
            'FACEBLACKLISTSCORE': 'Similarity to Blacklisted Faces via ID Photo',
            'FACESEARCHEXISTENCE': 'Face Search DB Check',
            'IDTYPEIDENTIFICATION': 'ID Type Identification',
            'SUNGLASSESDETECTION': 'Sunglasses Existence Check',
            'FACELIVENESSEYEMOVEMENT': 'Eye Movement Check',
            'BDV': 'Birth Date Validity Check',
            'EDV': 'Expiry Date Validity Check',
            'SNV': 'Serial Number Validity Check',
            'AFR': 'All Fields Read Check',
            'PRESENTATIONIMAGEAI': 'Face AI Score',
            'FACEIMAGEAI_1': 'First Face AI Score',
            'FACEIMAGEAI_2': 'Second Face AI Score',
            'FWVEMOTION_APPROVAL': 'Emotion Analysis at Confirmation Check',
            'ID Front Checks': 'ID Front Checks',
            'ID Back Checks': 'ID Back Checks',
            'Tamper Detections': 'Tamper Detections',
            'Finger Placement on ID Checks': 'Finger Placement on ID Checks',
            'Hologram Video Checks': 'Hologram Video Checks',
            'NFC Checks': 'NFC Checks',
            'Selfie with ID Checks': 'Selfie with ID Checks',
            'Liveness Video Checks': 'Liveness Video Checks',
            'Serial Number Verification Checks': 'Serial Number Verification Checks',
            'Voice Confirmation Checks': 'Voice Confirmation Checks',
            'Other Checks': 'Other Checks',
            'FACELIVENESS': 'Total Liveness Score',
            'FACE': 'Face Similarity Score via Liveness',
            'HIDDENPHOTO': 'Hidden Photo Detection',
            'HIDDENPHOTOOCR': 'Hidden Photo Code Check',
            'SIGNATUREPHOTO': 'Signature Detection',
            'MRZOCRCROSSSIMILARITY': 'MRZ - OCR Cross Similarity',
            // Archive titles
            'ID Front Archive': 'ID Front Archive',
            'ID Back Archive': 'ID Back Archive',
            'ID Front Uncropped': 'ID Front Uncropped',
            'ID Back Uncropped': 'ID Back Uncropped',
            'Fingerprint Archive': 'Fingerprint Archive',
            'Finger Placement Archive': 'Finger Placement on ID Archive',
            'Hologram Video Archive': 'Hologram Archive',
            'NFC Portrait Archive': 'NFC Portrait Archive',
            'Selfie with ID Archive': 'Selfie with ID Archive',
            'Liveliness Video Archive': 'Liveliness Video Archive',
            'Serial Number Verification Archive': 'Serial Number Verification Video Archive',
            'Voice Confirmation Archive': 'Voice Confirmation Video Archive',
            'ID Face Archive': 'ID Portrait Archive',
            'Signature Archive': 'Signature Archive',
            'Hidden Photo Archive': 'Hidden Photo Archive',
            'Liveness with ID Card Archive': 'Selfie with ID Front Archive',
            'Liveness with ID Card Back Archive': 'Selfie with ID Back Archive',
            // Regular file type titles
            'Voice Liveness Serial': 'Voice Liveness Serial',
            'Voice Liveness Approval': 'Voice Liveness Approval',
            'Voice Liveness Audio Serial': 'Voice Liveness Audio Serial',
            'Voice Liveness Audio Approval': 'Voice Liveness Audio Approval',
            'Voice Liveness Frame Approval': 'Voice Liveness Frame Approval',
            'Liveness with ID Card': 'Liveness with ID Card',
            'GUILLOCHEVERIFICATION': 'Guilloche Detection',
            'RAINBOWVERIFICATION': 'Rainbow Detection',
            'MRZNFCSIMILARITY': 'MRZ - NFC Similarity',
            'MRZOCRSIMILARITY': 'MRZ - OCR Similarity',
            'DRIVERBARCODEIDMATCH': 'Driving Licence Barcode Check',
            'IDCARDBARCODEIDMATCH': 'ID Card Barcode Check',
            'IDDOCIDMATCH': 'ID No Match of Document',
            'IDDOCNAMEMATCH': 'Name Match of Document',
            'IDDOCSURNAMEMATCH': 'Surname Match of Document',
            'FACELIVENESSGESTURE': 'Face Mimic Detection',
            'FACELIVENESSAI': 'Liveness AI Score',
            'MRZBIRTHDATECHECKSUM': 'Date of Birth Check Digit',
            'MRZEXPDATECHECKSUM': 'Expiry Date Check Digit',
            'MRZDOCNUMCHECKSUM': 'Document Number Check Digit',
            'NFCMRZSIMILARITY': 'NFC - MRZ Similarity',
            'NFCOCRFACESIMILARITY': 'NFC - OCR Face Similarity',
            'NFCOCRSIMILARITY': 'NFC - OCR Similarity',
            'AMLVALIDATION': 'AML Check',
            'NVIPROVEIDWITHHOLDER': 'NVI Check',
            'Include Transactions Without...': 'Include Transactions Without Media',
            'Include Transactions Without Media': 'Include Transactions Without Media',
            'Hide transactions where media and data are empty': 'Hide transactions where media and data are empty',
            'Show transactions with data but no media': 'Show transactions with data but no media',
            'Include transactions where media and data are empty': 'Include transactions where media and data are empty',
            'OCRLETTERCASEMATCH': 'Letter Case Match Check',
            'OCRMRZSIMILARITY': 'OCR - MRZ Similarity',
            'OCRNFCFACESIMILARITY': 'OCR - NFC Face Similarity',
            'OCRNFCSIMILARITY': 'OCR - NFC Similarity',
            'OLDIDSECONDARYINFORMATION': 'Area Match Check',
            'IDCARD': 'TR ID Card',
            'OLDIDCARD': 'TR Old ID',
            'PASSPORT': 'Passport',
            'DRIVERCARD': 'TR Driving Licence',
            'FOREIGNID': 'Residence Permit Document',
            'FOREIGNIDTYPEA': 'Residence Permit',
            'Threshold Warning': 'Threshold Warning',
            'This threshold will be reflected in reports but you will not be able to see it on screen. Do you want to continue?': 'This threshold will be reflected in reports but you will not be able to see it on screen. Do you want to continue?',
            'Threshold will be reflected in reports but not visible on screen': 'Threshold will be reflected in reports but not visible on screen',
            'Update Warning': 'Update Warning',
            'If you make an update, the control will be activated': 'If you make an update, the control will be activated',
            'FOREIGNIDTYPEB': 'Residence Permit',
            'FOREIGNIDTYPEC': 'Residence Permit',
            'FOREIGNIDTYPED': 'Temporary Protection ID Card',
            'SCREENATTACK': 'Screen Attack Safety',
            'oldidfront': 'Old ID Front (Processed) ',
            'passport': 'Passport',
            'driverface': 'Driver Portrait',
            'newdriverfront': 'TR Driving Licence',
            'turkishbluecardface': 'Blue Card Portrait',
            'turkishbluecardfront': 'Blue Card Front',
            'ocr': 'OCR',
            'oldidface': 'Old ID Face',
            'browser': 'Browser',
            'city': 'City',
            'country': 'Country',
            'device': 'Device',
            'ip': 'IP',
            'language': 'Language',
            'Identity No': 'Identity No',
            'Document No': 'Document No',
            'Licence Number': 'Licence Number',
            'Passport No': 'Passport No',
            'Video Call ID': 'Video Call ID',
            'not-found': 'Document not found',
            'identity_no': 'Identity No',
            'name': 'Name',
            'surname': 'Surname',
            'birthdate': 'Date of Birth',
            'document_no': 'Document No',
            'valid_until': 'Valid Until',
            'vcface': 'Face at Video Call',
            'vcidfront': 'ID Front at Video Call',
            'vcidback': 'ID Back at Video Call',
            'vcidclosed': 'Hand Landmark at Video Call',
            'vcidfrontphotoblocked': 'ID Front Photo Blocked at Video Call',
            'vcidfrontsignatureblocked': 'ID Front Signature Blocked at Video Call',
            'vcidfronthiddenphotoblocked': 'ID Front Hidden Photo Blocked at Video Call',
            'vcidfrontstarandcrescentblocked': 'ID Front Star and Crescent Blocked at Video Call',
            'vcidbackbarcodeblocked': 'ID Back Barcode Blocked at Video Call',
            'nationality': 'Nationality',
            'gender': 'Gender',
            'mother_name': 'Mother Name',
            'father_name': 'Father Name',
            'birth_place': 'Birth Place',
            'alternativeName': 'Alternative Name',
            'alternativeSurname': 'Alternative Surname',
            'agent': 'Agent',
            'agent_lead': 'Agent Lead',
            'admin': 'Admin',
            'EXPIREDOC': 'The document has expired',
            'NOTFOUNDDOC': 'Document not found',
            'WRONGDOCTYPE': 'Document type wrong',
            'NOTORIGINAL': 'The document is not original',
            'select_language': 'Select Country',
            'select_language_desc':
                'Please select your country to continue with ID card verification.',
            'select_template': 'Choose Template Type',
            'select_template_desc':
                'To continue with ID card verification, please select your template type.',
            'FOREIGNIDBACK': 'Foreign ID (Back)',
            'ID-Front': 'Front of ID Card',
            'ID-Back': 'Back of ID Card',
            'ID': 'ID Card',
            'ID-NFC': 'NFC Reading',
            'Hologram': 'Hologram Video',
            'Liveness': 'Liveness Video',
            'Others': 'Other Controls',
            'NFC Controls': 'NFC Certificate Checks',
            'Metadata': 'OCR Results & Meta Data',
            'User Approval Screen': 'Users Waiting for Approval',
            'CONFIRMED': 'Görüşme tamamlandı, kullanıcı onaylandı',
            'DECLINED': 'Görüşme tamamlandı, kullanıcı reddedildi',
            'TECHNICAL_FAILURE': 'Teknik bir arıza sebebiyle devam edilemedi',
            'CUSTOMER_FAILURE': 'Müşteri sebebiyle devam edilemedi',
            'WAITING': 'Waiting for agent decision',
            '_Status': 'Status',
            'login_attempt': 'Your user has an unsuccessful login attempt on {{ date }}',
            'HEAD-HORIZONTAL': ' - Horizontal Head Movement Gesture Video',
            'HEAD-VERTICAL': ' - Vertical Head Movement Gesture Video',
            'EYE': ' - Eye Gesture Video',
            'MOUTH': ' - Mouth Gesture Video',
            'HH': ' - Horizontal Head Movement Gesture Video',
            'HV': ' - Vertical Head Movement Gesture Video',
            'E': ' - Eye Gesture Video',
            'M': ' - Mouth Gesture Video',
            'Acceptance Threshold': 'Acceptance Threshold',
            'Security Threshold': 'Security Threshold',
            'Old': 'Old',
            'New': 'New',
            'new_id': 'TR New ID Front',
            'new_id_back': 'TR New ID Back',
            'old_id': 'TR Old ID Front',
            'old_id_back': 'TR Old ID Back',
            'new_driver': 'TR Driving Licence Front',
            'new_driver_back': 'TR Driving Licence Back',
            'old_driver': 'TR Old Driving Licence Front',
            'old_driver_back': 'TR Old Driving Licence Back',
            'address_confirmation_document': 'Address Confirmation Document',
            'signature_document': 'Signature',
            'mobile': 'Mobile',
            'answeredCallsCount': 'Answered Calls',
            'answeredCallsRatio': 'Answered Call Ratio (%)',
            'answeredCallsTotalWaitingTime': 'Total Waiting Time for Answered Calls',
            'avgAnsweredCallsWaitingTime': 'Average Waiting Time for Answered Calls',
            'avgMeetingTime': 'Average Meeting Time',
            'avgWaitingTime': 'Average Waiting Time',
            'maxWaitingTime': 'Max. Waiting Time',
            'totalCallsCount': 'Total Calls',
            'totalMeetingTime': 'Total Meeting Time',
            'totalWaitingTime': 'Total Waiting Time',
            'inbound.answeredCalls': 'Total Number of Answered Calls',
            'inbound.rejectedCalls': 'Total Number of Rejected Calls',
            'inbound.totalMeetingTime': 'Total Meeting Time',
            'inbound.avgMeetingTime': 'Average Meeting Time',
            'inbound.totalWaitingTime': 'Total Call Response Time',
            'inbound.avgWaitingTime': 'Average Call Response Time',
            'totalActiveTime': 'Total Active Time',
            'totalPassiveTime': 'Total Passive Time',
            'hostFullName': 'Agent',
            'call_no': 'Call No',
            'queueInfo.queueName': 'Queue Name',
            'host.fullname': 'Person receiving call',
            'customer.fullName': 'Customer name',
            'queueEntryDate': 'Queue Entry Time',
            'waitingTime': 'Waiting Time',
            'meetingTime': 'Length of Meeting',
            'appointmentId': 'Appointment No',
            '$appointmentId': 'Status',
            'availableAgents': 'Available agents',
            'host.fullName': 'Person receiving call',
            'queueName': 'Queue Name',
            'customerFullname': 'Customer Name',
            'callReceivedTime': 'Time of Call Reaching Agent',
            'meetingCompletedDate': 'Meeting Completed Time',
            'response': 'Status',
            'candidateQueueMeetingInfoId': 'Call No',
            'SCREENATTACKBACK': 'Screen Attack (Back)',
            'MRZCOMPOSITECHECKSUM': 'Composite Check Digit',
            'MRZCOMPOSITECHECKSUMVALID': 'Composite Check Digit Validity',
            'FACEPHOTOEXISTENCE': 'Photo Existence Check',
            'CHIPDETECTION': 'Chip Existence Check',
            'ACTIVE': 'Active',
            'PASSIVE': 'Deactivated',
            'Hand': 'Hand Landmark on ID',
            'Card-Hold-Liveliness': 'Liveness with Card',
            'HANDLANDMARKTYPEMATCH THUMBRIGHTDOWN': 'Hand Landmark ID Type Check',
            'HANDLANDMARKSCORE THUMBRIGHTDOWN': 'Covering the Bottom Right Corner of the ID',
            'HANDLANDMARKTYPEMATCH THUMBRIGHTUP': 'Hand Landmark ID Type Check',
            'HANDLANDMARKSCORE THUMBRIGHTUP': 'Covering the Upper Right Corner of the ID',
            'HANDLANDMARKTYPEMATCH THUMBLEFTDOWN': 'Hand Landmark ID Type Check',
            'HANDLANDMARKSCORE THUMBLEFTDOWN': 'Covering the Bottom Left Corner of the ID',
            'HANDLANDMARKTYPEMATCH THUMBLEFTUP': 'Hand Landmark ID Type Check',
            'HANDLANDMARKSCORE THUMBLEFTUP': 'Covering the Upper Left Corner of the ID',
            'LWICONLYFRONCARDTYPESIMILARITY': 'Card Type Check at Liveness with Card',
            'LWICONLYFRONTFACESIMILARITY (A-D)': 'Face Similarity Score via Liveness with Card',
            'LWICONLYFRONTOCRSIMILARITY': 'OCR Similarity Score via Liveness with Card',
            'LWICLIVENESSAI': 'Liveness AI Score Score via Liveness with Card',
            'LWICSELFIEFIRSTIDFACESIMILARITY(A-C)':
                'Face Similarity across ID Cards via Liveness with Card',
            'PHOTOSHOPCONTROLBACK': 'Photoshop Check Back Face',
            'PHOTOSHOPCONTROL': 'Photoshop Check Front Face',
            'APPROVAL': 'Confirmation Check',
            'SERIALNUMBER': 'Serial Number Check',
            'THUMBLEFTUP': 'Hand Landmark on ID Check',
            'THUMBLEFTUPTHUMBLEFTUP': 'Hand Landmark Up Left',
            'THUMBRIGHTUP': 'Hand Landmark on ID Check',
            'THUMBRIGHTUPTHUMBRIGHTUP': 'Hand Landmark Up ',
            'THUMBLEFTDOWN': 'Hand Landmark on ID Check',
            'THUMBLEFTDOWNTHUMBLEFTDOWN': 'Hand Landmark Left Down',
            'THUMBRIGHTDOWN': 'Hand Landmark on ID Check',
            'THUMBRIGHTDOWNTHUMBRIGHTDOWN': 'Hand Landmark Down',
            'THUMBRIGHTLEFTUP': 'Hand Landmark on ID Check',
            'THUMBRIGHTLEFTUPTHUMBRIGHTLEFTUP': 'Hand Landmark Left Up',
            'THUMBRIGHTLEFTDOWN': 'Hand Landmark on ID Check',
            'THUMBRIGHTLEFTDOWNTHUMBRIGHTLEFTDOWN': 'Hand Landmark Left Down',
            // Media type translations
            'newidfront': 'ID Front',
            'secondaryidfile': 'ID Back',
            'newidfront_frame': 'ID Front Uncropped',
            'secondaryidfile_frame': 'ID Back Uncropped',
            'newidfront_': 'ID Front Uncropped',
            'secondaryidfile_': 'ID Back Uncropped',
            'handlandmark_THUMBRIGHTDOWN': 'Finger Placement on ID',
            'handlandmark_THUMBRIGHTUP': 'Finger Placement on ID',
            'handlandmark_THUMBLEFTDOWN': 'Finger Placement on ID',
            'handlandmark_THUMBLEFTUP': 'Finger Placement on ID',
            'hologram': 'Hologram Video',
            'nfcbiometricpicture': 'NFC Portrait',
            'livenessonlyface': 'Selfie with ID',
            'face': 'Liveness Video',
            'livenessframe': 'Liveness Face Picture',
            'facewithvoice_SERIALNUMBER': 'Serial Number Verification Video',
            'facewithvoice_APPROVAL': 'Voice Confirmation Video',
            'newidface': 'ID Portrait',
            'signature': 'Signature',
            'hiddenphoto': 'Hidden Photo',
            'livenesswithidfront': 'Selfie with ID Front',
            'livenesswithidfrontandface': 'Selfie with ID Front',
            'livenesswithidback': 'Selfie with ID Back',
            'livenesswithidbackandface': 'Selfie with ID Back',
            'facewithvoiceaudio_SERIALNUMBER': 'Serial Number Verification Video Audio',
            'livenesswithvoiceframe_SERIALNUMBER': 'Serial Number Verification Video Frame',
            'livenesswithvoiceframe_APPROVAL': 'Voice Confirmation Video Frame',
            'facewithvoiceaudio_APPROVAL': 'Voice Confirmation Video Audio',
            'LWICONLYFRONTFACESIMILARITY':
                'Face Similarity Score Across ID Cards via Liveness with Card',
            'LWICSELFIEFIRSTIDFACESIMILARITY': 'Face Similarity Score via Liveness with Card',
            'Voice': 'Voice Check Steps',
            'FWVLIVENESSAI SERIALNUMBER': 'Liveness AI Score at Serial Number Check',
            'FWVLIVENESSAI APPROVAL': 'Total Liveness Score at Confirmation Check',
            'FWVLIVENESSGESTURE SERIALNUMBER': 'Gesture Detection at Serial Number Check',
            'FWVLIVENESSFACECONSAVG SERIALNUMBER':
                'Average Face Similarity Score at Serial Number Check',
            'FWVLIVENESSFACECONSPER SERIALNUMBER': 'Valid Face Ratio at Serial Number Check',
            'FWVFACE SERIALNUMBER': 'Face Similarity Score at Serial Number Check',
            'FWVAGE SERIALNUMBER': 'Age Prediction at Serial Number Check',
            'FWVGENDER SERIALNUMBER': 'Gender Prediction at Serial Number Check',
            'FWVSPEECHMATCH SERIALNUMBER': 'Expression Accuracy at Serial Number Check',
            'FWVLIVENESS APPROVAL': 'Total Liveness Score at Confirmation Check',
            'FWVLIVENESSGESTURE APPROVAL': 'Gesture Detection at Confirmation Check',
            'FWVLIVENESSFACECONSAVG APPROVAL':
                'Average Face Similarity Score at Confirmation Check',
            'FWVLIVENESSFACECONSPER APPROVAL': 'Valid Face Ratio at Confirmation Check',
            'FWVFACE APPROVAL': 'Face Similarity Score at Confirmation Check',
            'FWVAGE APPROVAL': 'Age Prediction at Confirmation Check',
            'FWVGENDER APPROVAL': 'Gender Prediction at Confirmation Check',
            'FWVSPEECHMATCH APPROVAL': 'Expression Accuracy at Confirmation Check',
            'FWVSPEECHCONSISTENCY APPROVAL': 'Voice Compatibility at Confirmation Check',
            'SECURITYOBJECTVERIFICATION': 'Interpretation of Security Elements',
            'Export completed successfully': 'Export completed successfully',
            "Couldn't export data": "Couldn't export data",
            
            'device_controls': 'Device Controls',
            'identity': 'Identity',
            'liveness': 'Liveness',
            'nfc': 'NFC',
            'id_front_face': 'ID Front Face',
            'id_back_face': 'ID Back Face',
            'liveness_passive_photo': 'Liveness Passive Photo',
            'liveness_passive_video': 'Liveness Passive Video',
            'liveness_active_eye_blink': 'Liveness Active Eye Blink',
            'liveness_active_left_right': 'Liveness Active Left Right',
            'liveness_active_up_down': 'Liveness Active Up Down',
            'id_selection': 'ID Selection',

            'error': 'Error',
            'step_started': 'Step Started',
            'detection': 'Detection',
            'step_completed': 'Step Completed',

            'insufficient_light_detected': 'Insufficient light detected',
            'insufficient_connection_speed': 'Insufficient connection speed',
            'insufficient_camera': 'Insufficient camera',
            'no_camera_flash': 'No camera flash',
            'different_id_type_shown': 'Different ID type shown than requested',
            'other_side_of_id_shown': 'Other side of ID shown',
            'id_held_too_far': 'ID held too far',
            'id_held_too_close': 'ID held too close',
            'image_not_clear': 'Image not clear',
            'multiple_faces_detected': 'Multiple faces detected',
            'no_face_detected': 'No face detected',
            'face_held_too_close': 'Face held too close',
            'face_held_too_far': 'Face held too far',
            'connection_disconnected': 'Connection disconnected',
            'mrz_chip_data_mismatch': 'MRZ and chip data mismatch',
            'card_not_approached': 'Card not approached',
            'device_control_step_started': 'Device control step started',
            'id_front_face_step_started': 'ID front face step started',
            'id_back_face_step_started': 'ID back face step started',
            'nfc_step_started': 'NFC step started',
            'hologram_step_started': 'Hologram step started',
            'liveness_passive_photo_step_started': 'Liveness passive photo step started',
            'liveness_passive_video_step_started': 'Liveness passive video step started',
            'liveness_active_eye_blink_step_started': 'Liveness active eye blink step started',
            'liveness_active_left_right_step_started': 'Liveness active left right step started',
            'liveness_active_up_down_step_started': 'Liveness active up down step started',
            'sufficient_light_available': 'Sufficient light available',
            'connection_speed_appropriate': 'Connection speed appropriate',
            'sufficient_camera_available': 'Sufficient camera available',
            'camera_flash_available': 'Camera flash available',
            'id_selection_made_new_id': 'ID selection made - New ID',
            'id_selection_made_driver': 'ID selection made - Driver License',
            'id_selection_made_passport': 'ID selection made - Passport',
            'id_selection_made_blue_card': 'ID selection made - Blue Card',
            'id_selection_made_foreign_id': 'ID selection made - Foreign ID',
            'device_controls_step_completed': 'Device controls step completed',
            'id_front_face_step_completed': 'ID front face step completed',
            'id_back_face_step_completed': 'ID back face step completed',
            'nfc_step_completed': 'NFC step completed',
            'hologram_step_completed': 'Hologram step completed',
            'liveness_passive_video_step_completed': 'Liveness passive video step completed',
            'liveness_passive_photo_step_completed': 'Liveness passive photo step completed',
            'liveness_active_eye_blink_step_completed': 'Liveness active eye blink step completed',
            'liveness_active_left_right_step_completed': 'Liveness active left right step completed',
            'liveness_active_up_down_step_completed': 'Liveness active up down step completed',

            'Process Step': 'Process Step',
            'Record Description': 'Record Description',
            'Record Type': 'Record Type',
            'Unknown': 'Unknown',
            'No description found': 'No description found',
            'Info': 'Info',
            'All': 'All',
            'ONBOARD': 'Onboard',
            'PASSWORD': 'Password',
            'Process Type': 'Process Type',
            'User Management': 'User Management',
            'Groups': 'Groups',
            'Role Groups': 'Role Groups',
            'Pending Group Request': 'Pending Group Request',
            'Pending Group Requests': 'Pending Group',
            'Request Type': 'Request Type',
            'Role Group Create': 'Role Group Create',
            'Role Group Update': 'Role Group Update',
            'Role Group Delete': 'Role Group Delete',
            'User Create': 'User Create',
            'User Update': 'User Update',
            'Add New Role Group': 'Add New Role Group',
            'Role Group Name': 'Role Group Name',
            'Roles': 'Roles',
            'Checker Username': 'Checker Username',
            'Select Request Type': 'Select Request Type',
            'Select roles': 'Select roles',
            'Select checker': 'Select checker',
            'Enter role group name': 'Enter role group name',
            'Enter checker username or email': 'Enter checker username or email',
            'No roles available. Please create role groups first.': 'No roles available. Please create role groups first.',
            'Approve Request': 'Approve Request',
            'Decline Request': 'Decline Request',
            'Do you want to approve the creation of role group "{{name}}" with roles: {{roles}}?': 'Do you want to approve the creation of role group "{{name}}" with roles: {{roles}}?',
            'Do you want to approve the update of role group "{{name}}" with roles: {{roles}}?': 'Do you want to approve the update of role group "{{name}}" with roles: {{roles}}?',
            'Do you want to approve the deletion of role group "{{name}}"?': 'Do you want to approve the deletion of role group "{{name}}"?',
            'Do you want to approve the creation of user "{{user}}"?': 'Do you want to approve the creation of user "{{user}}"?',
            'Do you want to approve the update of user "{{user}}"?': 'Do you want to approve the update of user "{{user}}"?',
            'Do you want to approve this request?': 'Do you want to approve this request?',
            'Do you want to decline the creation of role group "{{name}}"?': 'Do you want to decline the creation of role group "{{name}}"?',
            'Do you want to decline the update of role group "{{name}}"?': 'Do you want to decline the update of role group "{{name}}"?',
            'Do you want to decline the deletion of role group "{{name}}"?': 'Do you want to decline the deletion of role group "{{name}}"?',
            'Do you want to decline the creation of user "{{user}}"?': 'Do you want to decline the creation of user "{{user}}"?',
            'Do you want to decline the update of user "{{user}}"?': 'Do you want to decline the update of user "{{user}}"?',
            'Do you want to decline this request?': 'Do you want to decline this request?',
            'Role group approved successfully': 'Role group approved successfully',
            'Request approved successfully': 'Request approved successfully',
            'Role group declined successfully': 'Role group declined successfully',
            'Request declined successfully': 'Request declined successfully',
            'Role group creation request sent successfully': 'Role group creation request sent successfully',
            'Couldn\'t fetch role groups': 'Couldn\'t fetch role groups',
            'Couldn\'t fetch pending group requests': 'Couldn\'t fetch pending group requests',
            'Couldn\'t approve request': 'Couldn\'t approve request',
            'Couldn\'t decline request': 'Couldn\'t decline request',
            'Couldn\'t create role group': 'Couldn\'t create role group',
            'Please enter role group name': 'Please enter role group name',
            'Please select at least one role': 'Please select at least one role',
            'Please enter checker username': 'Please enter checker username',
            'No roles': 'No roles',
            'Maker': 'Maker',
            'Roles / Role Group': 'Roles / Role Group',
            'Role Group ID': 'Role Group ID',
            'Only users with checker or role-checker role can list role groups': 'Only users with checker or role-checker role can list role groups',
            'Edit Role Group': 'Edit Role Group',
            'Delete Role Group': 'Delete Role Group',
            'Update Role Group': 'Update Role Group',
            'Role group update request sent successfully': 'Role group update request sent successfully',
            'Role group deletion request sent successfully': 'Role group deletion request sent successfully',
            'Cannot delete role group with assigned users. User count: {{count}}': 'Cannot delete role group with assigned users. User count: {{count}}',
            'Warning: This role group has {{count}} assigned user(s).': 'Warning: This role group has {{count}} assigned user(s).',
            'Do you want to delete role group "{{name}}"?': 'Do you want to delete role group "{{name}}"?',
            'Couldn\'t update role group': 'Couldn\'t update role group',
            'Couldn\'t delete role group': 'Couldn\'t delete role group',
            'Group': 'Group',
            'Group Name': 'Group Name',
            'Create Group': 'Create Group',
            'Edit Group': 'Edit Group',
            'Group List': 'Group List',
            'Permissions': 'Permissions',
            'Select Permissions': 'Select Permissions',
            'Save': 'Save',
            'Cancel': 'Cancel',
            'Delete': 'Delete',
            'Edit': 'Edit',
            'No groups found': 'No groups found',
            'Group created successfully': 'Group created successfully',
            'Group updated successfully': 'Group updated successfully',
            'Group deleted successfully': 'Group deleted successfully',
            'Are you sure you want to delete this group?': 'Are you sure you want to delete this group?',
            'Selected': 'Selected',
            'is required': 'is required',
            'No permissions available': 'No permissions available',
            'Please select at least one permission': 'Please select at least one permission',
            'Video Call Agents': 'Video Call Agents',
            'Agent ID': 'Agent ID',
            'Queue Code': 'Queue Code',
            'Provider': 'Provider',
            'Edit Agent': 'Edit Agent',
            'Agent updated successfully': 'Agent updated successfully',
            'Update': 'Update',
            'Video Call Status': 'Video Call Status',
            'Total Rows': 'Total Rows',
            'Unique Transactions': 'Unique Transactions',
            'Unique Identities': 'Unique Identities',
            'Status Breakdown': 'Status Breakdown',
            'Status with Details': 'Status with Details',
            'No data available': 'No data available',
            'Select Agent': 'Select Agent',
            'Passed Tid': 'Passed Tid',
            'Failed Tid': 'Failed Tid',
            'Recording': 'Recording',
            'Recording Stopped': 'Recording Stopped',
            'DECLINED_SCREEN_SHARE': 'Screen Share Declined',
            'Screen recording permission denied': 'Screen recording permission denied',
            'Add Customer': 'Add Customer',
            'Customer added successfully': 'Customer added successfully',
            'External System ID': 'External System ID',
            'Please fill in the required fields marked with *': 'Please fill in the required fields marked with *',
            'Failed to add customer': 'Failed to add customer',
            'Select Status': 'Select Status',
            'All Status': 'All Status',
            'Inactive': 'Inactive',
            'Pending': 'Pending',
            'Note': 'Note',
            'Email': 'Email',
            'ID Number': 'ID Number',
            'Add File': 'Add File',
            'Mime Type': 'Mime Type',
            'Click to select a file or paste an image': 'Click to select a file or paste an image',
            'Select File': 'Select File',
            'Supported formats: Images and PDF': 'Supported formats: Images and PDF',
            'File': 'File',
            'Remove File': 'Remove File',
            'File Added Successfully': 'File Added Successfully',
            'File uploaded successfully': 'File uploaded successfully',
            'Would you like to add another file or complete the process?': 'Would you like to add another file or complete the process?',
            'Add Another File': 'Add Another File',
            'Complete': 'Complete',
            'TR New ID': 'TR New ID',
            'TR Old ID': 'TR Old ID',
            'Passport': 'Passport',
            'TR Driving Licence': 'TR Driving Licence',
            'TR Old Driving Licence': 'TR Old Driving Licence',
            'Address Confirmation Document': 'Address Confirmation Document',
            'Signature': 'Signature',
            'Other': 'Other',
            'Edit Customer': 'Edit Customer',
            'Update Customer': 'Update Customer',
            'Customer updated successfully': 'Customer updated successfully',
            'Failed to update customer': 'Failed to update customer',
            'Documents': 'Documents',
            'files': 'files',
            'Use arrow keys or click arrows to navigate': 'Use arrow keys or click arrows to navigate',
            'completed': 'Completed',
            'pending': 'Pending',
            'Quality Monitoring': 'Quality Monitoring',
            'Quality Listening Status': 'Quality Listening Status',
            'Quality Listening Date': 'Quality Listening Date',
            'Quality Controller': 'Quality Controller',
            'Video Call Agent': 'Video Call Agent',
            'Quality Listening Done': 'Quality Listening Done',
            'Quality Notes': 'Quality Notes',
            'Save Quality Information': 'Save Quality Information',
        },
    },
    ru: {
        translation: {
            'transactionType': 'Тип транзакции',
            'Show transactions with data but no media': 'Показать транзакции с данными, но без медиа',
            'Name Surname': 'Имя Фамилия',
            'Registration Date': 'Дата регистрации',
            'Submitted Files': 'Отправленные файлы',
            'Submit': 'Отправить',
            'Status': 'Статус',
            'Verification Score': 'Оценка проверки',
            'Agent': 'Агент',
            'agent': 'Агент',
            'agent_lead': 'Ведущий агент',
            'admin': 'Администратор',
            'Control': 'Контроль',
            'Result': 'Результат',
            'Outcome': 'Исход',
            'Entry Type': 'Тип записи',
            'Entry Score': 'Оценка записи',
            'Entry Interpretation': 'Интерпертация записи',
            'Validation': 'Проверка',
            'Acceptable': 'Приемлемо',
            'Media Type': 'Тип носителя',
            'Actions': 'Действия',
            'Open': 'Открыть',
            'Download': 'Скачать',
            'Meta Title': 'Мета-заголовок',
            'Value': 'Значение',
            'Info Title': 'Заголовок информации',
            "Couldn't get media information": 'Не удалось получить информацию о носителе',
            "Couldn't get export": 'Не удалось получить экспорт',
            'Identity Acceptable': 'Идентификация приемлема',
            'Identity Information Validity': 'Срок действия идентификационной информации',
            'Biometric Photo Validity': 'Срок действия биометрических фотографий',
            'Encryption Validity': 'Срок действия шифрования',
            'Certificate Validity': 'Срок действия сертификата',
            'Created At': 'Создано',
            'Name': 'Имя',
            'Surname': 'Фамилия',
            'Birth Date': 'Дата рождения',
            'Document Type': 'Тип документа',
            'Identity No': 'Идентификационный номер',
            'Expiry Date': 'Дата истечения срока',
            'Delete Confirmation': 'Удалить подтверждение',
            'The data you selected will be completely removed. Do you want to continue?':
                'Выбранные данные будут полностью удалены. Продолжить?',
            'Cancel': 'Отмена',
            'Confirm': 'Подтвердить',
            'Control Results': 'Результаты контроля',
            'Confidence': 'Надежность',
            'Identity': 'Личность',
            'Video & Image': 'Видео и изображеие',
            'Metadata': 'Результаты и мета дата OCR',
            'NFC Controls': 'Проверка сертификата NFC',
            'Please Wait...': 'Пожалуйста ожидайте...',
            'Details': 'Детали',
            'Export': 'Экспорт',
            'Report': 'Отчет',
            'Rows per page:': 'Строки на странице',
            'Home': 'Назад',
            'Person': 'Личность',
            'Settings': 'Настройки',
            'Logout': 'Выйти',
            'Support': 'Поддержка',
            'Verifications': 'Проверки',
            'Verification Details': 'Детали проверки',
            'Verification Result': 'Результаты проверки',
            'Quality Monitoring': 'Контроль качества',
            'Quality Listening Status': 'Статус прослушивания качества',
            'Quality Listening Date': 'Дата прослушивания качества',
            'Quality Controller': 'Контролер качества',
            'Video Call Agent': 'Агент видеозвонка',
            'Quality Listening Done': 'Прослушивание качества выполнено',
            'Quality Notes': 'Заметки по качеству',
            'Save Quality Information': 'Сохранить информацию о качестве',
            'Awaiting Calls': 'Ожидание звонков',
            'Awaiting Calls (Live)': 'Ожидание звонков (в прямом эфире)',
            'Call': 'Звонок',
            'Waiting Time': 'Время ожидания',
            'You will return to back page. Do you want to continue?':
                'Вы вернетесь на предыдущую страницу. Вы хотите продолжить?',
            'ID Info': 'Идентификационная информация',
            'NFC Info': 'Инофрмация с NFC',
            'Controls': 'Управления',
            'Media': 'Носитель',
            'Signing, Please Wait...': 'Идет подписание. Пожалуйста ожидайте...',
            'Customers': 'Клиенты',
            'oldidface': 'Лицо со старого удостоверения личности',
            'Search Name': 'Поиск имени',
            'Last Attempt': 'Последняя попытка',
            'Phone': 'Номер телефона',
            'E-Mail': 'Электронная почта',
            'Customer Details': 'Информация о клиенте',
            'Transaction ID': 'Номер транзакции',
            'Verification Date': 'Дата проверки',
            'city': 'Город',
            'country': 'Страна',
            'device': 'Устройство',
            'ip': 'IP',
            'language': 'Язык',
            'Document No': 'Номер документа',
            'Licence Number': 'Номер лицензии',
            'Passport No': 'Номер паспорта',
            'Awaiting Documents': 'Ожидание документов',
            'Confirm Document': 'Подтверждение документов',
            'Confirmed Documents': 'Подтвержденные документы',
            'Document Details': 'Информация о документе',
            'Identity Number': 'Идентификационный номер',
            'Decline': 'Отклонить',
            'This document was marked as CONFIRMED.': 'Этот документ отмечен как ПОДТВЕРЖДЕННЫЙ',
            'Do you confirm?': 'Вы подтверждаете?',
            'Check Again': 'Проверьте еще раз',
            'This document was REJECTED.': 'Этот документ был ОТКЛОНЕН',
            'Choose the reason for rejection': 'Выберите причину для отклонения',
            'The document has expired': 'Срок действия документа истек',
            'Document not found': 'Документ не найден',
            'not-found': 'Документ не найден',
            'Document type wrong': 'Неверный тип документа',
            'Confirmation Date': 'Дата подтверждения',
            'Confirmation Status': 'Статус подтверждения',
            'Save': 'Сохранить',
            'Confirm or decline this document.': 'Подтвердите или отклоните документ',
            'Operation Completed': 'Операция завершена',
            'You are closing the selected document without making any choice. This document will not be available for confirmation for 3 minutes. Do you confirm?':
                'Вы закрываете выбранный документ, не осуществив какой либо выбор. Этот документ будет недоступен для подтверждения около 3 минут. Вы подтверждаете?',
            'Go back to the document': 'Вернуться к документу',
            'Change as Declined': 'Изменить как отклоненный',
            'Change as Approved': 'Изменить как одобрено',
            'Do you want to change?': 'Вы хотите внести изменения?',
            'Document current status': 'Текущий статус документа',
            'CONFIRMED': 'ПОДТВЕРЖДЕН',
            'DECLINED': 'ОТКЛОНЕН',
            'Personel Incorrect Entry': 'Неправильный ввод личных данных',
            'Document Barcode Number Incorrect Entry':
                'Неправильный ввод номера штрих-кода документа',
            'TCKN Incorrect Entry': 'Неправильный ввод TCKN',
            'Why is the document\'s "Approved" status changed to "Declined"?':
                'Почему статус документа "Подтвержден" изменен на "Отклонен"?',
            'Why is the document\'s "Declined" status changed to "Approved"?':
                'Почему статус документа "Отклонен" изменен на "Подтвержден"?',
            'Date': 'Дата',
            'Action': 'Действие',
            'Document History': 'История документа',
            'Blue Card': 'Синяя карта',
            'Residence Permit': 'Вид на жительство',
            'Temporary Protection ID': 'Удостоверение личности временной защиты',
            'German ID Card': 'Немецкое удостоверение личности',
            'Approved': 'Одобренный',
            'Document Detail': 'Сведения о документе',
            'Verification Detail': 'Сведения о проверке',
            'Change Status': 'Статус об изменении',
            'Please enter same password': 'Пожалуйста введите повторно пароль',
            'Back To Panel': 'Назад к панели',
            'Could not change your password': 'Не удалость изменить ваш пароль',
            'Old Password': 'Старый пароль',
            'New Password': 'Новый пароль',
            'Confirm New Password': 'Подтвердите новый пароль',
            'Save Password': 'Сохранить пароль',
            'Change Password': 'Изменить пароль',
            'Forgot Password?': 'Забыли пароль?',
            'Reset Password': 'Сбросить пароль',
            'E-mail': 'Электронный адрес',
            'Return': 'Вернуться',
            'Create New Password': 'Создать новый пароль',
            'Could not reset your password': 'Не удалость сбросить ваш пароль',
            'Check your E-mail': 'Проверьте вашу электронную почту',
            'Check your username': 'Проверьте вашу фамилию',
            'Sign In': 'Войти',
            'Password': 'Пароль',
            'Remember Me': 'Запомнить меня',
            'Create User': 'Создать пользователя',
            'Approve Users': 'Одобрить пользователей',
            'Approve': 'Одобрить',
            'Create': 'Создать',
            'User Approval Screen': 'Страница одобрения пользователя',
            'The document is not original': 'Документ не является оригиналом',
            'Select a reason for rejection of the document':
                'Выберите причину отклонения документа',
            'Uploaded': 'Загружено',
            'Awaiting': 'Ожидание',
            'Declined: Expired document': 'Отклонено: Документ просрочен',
            'Declined: Document not found': 'Отклонено: Документ не найден',
            'Declined: Document type wrong': 'Отклонено: Неверный тип документа',
            'Declined: Document is not original': 'Отклонено: Документ не является оригиналом',
            'Changed to declined: TCKN Incorrect Entry':
                'Изменено на отклонено: Неверный ввод TCKN',
            'Changed to declined: Document Barcode Number Incorrect Entry':
                'Изменено на отклонено: Неправильный ввод номера штрих-кода документа',
            'Changed to declined: Personel Incorrect Entry':
                'Изменено на отклонено: Неправильный ввод личных данных',
            'Declined': 'Отклонено',
            'Changed to approved: Personel Incorrect Entry':
                'Изменено на одобрено: Неправильный ввод личных данных',
            'All': 'Все',
            'ONBOARD': 'На борту',
            'PASSWORD': 'Пароль',
            'Process Type': 'Тип процесса',
            'Clear All': 'Очистить все',
            'Search': 'Поиск',
            'Additional Info': 'Дополнительная информация',
            'Phone Number': 'Номер телефона',
            'identity_no': 'Идентификационный номер',
            'name': 'Имя',
            'surname': 'Фамилия',
            'birthdate': 'Дата рождения',
            'document_no': 'Номер документа',
            'valid_until': 'Действителен до',
            'nationality': 'Национальность',
            'gender': 'Пол',
            'mother_name': 'Имя матери',
            'father_name': 'Имя отца',
            'birth_place': 'Место рождения',
            'The operation could not be performed due to an error.':
                'Операция не может быть выполнена из-за ошибки.',
            'We Value Your Privacy Preferences':
                'Мы ценим ваши предпочтения в отношении конфиденциальности',
            'This website gathers information about user interaction, personel information and biometric characteristics for secure consent collection.  This sensitive information will only enable you to sign documents securely and verifiably and will not be shared with third parties without your consent. Please confirm your consents to proceed.':
                'Этот веб-сайт собирает информацию о взаимодействии с пользователем, личную информацию и биометрические характеристики для безопасного сбора согласия. Эта конфиденциальная информация позволит вам безопасно и достоверно подписывать документы и не будет передаваться третьим лицам без вашего согласия. Пожалуйста, подтвердите свое согласие, чтобы продолжить.',
            'I have read and accepted the GDPR Complience':
                'Я прочитал и принял соглашение о об Общем регламенте по защите персональных данных',
            'Transaction Id': 'Номер транзакции',
            'Gesture': 'Жест',
            'Please select valid date ranges': 'Пожалуйста, выберите допустимые диапазоны дат',
            'ID Type': 'Тип удостоверения личности',
            'Progress': 'Продвижение',
            'ID Front': 'Лицевая сторона удостоверения личности',
            'ID Back': 'Обратная сторона удостоверения личности',
            'Liveness': 'Видео живости',
            'Address Document': 'Адресный документ',
            'Biometric Recognition & Verification': 'Биометрическое распознавание и проверка',
            'Please select one of the following identification documents for verification.':
                'Пожалуйста, выберите один из следующих документов, удостоверяющих личность, для проверки.',
            'For verification, first your ID photo, then your face photo is taken':
                'Для проверки сначала делается фотография вашего удостоверения личности, а затем фотография вашего лица.',
            'The verification result is created by evaluating the identity and face information.':
                'Результат проверки создается путем оценки личности и информации о лице.',
            'Authentications without user creation cannot be connected with any account and all information is deleted when you leave the page':
                'Аутентификации без создания пользователя не могут быть связаны с какой-либо учетной записью и вся информация удаляется, когда вы покидаете страницу.',
            'Authentications made by creating a user are linked to the user account and the results can be viewed through the ProveID Dashboard panel.':
                'Аутентификации, выполненные путем создания пользователя, связаны с учетной записью пользователя и результаты можно просмотреть на панели ProveID Dashboard.',
            'EXPIREDOC': 'Документ просрочен',
            'NOTFOUNDDOC': 'Документ не найден',
            'WRONGDOCTYPE': 'Неверный тип документа',
            'NOTORIGINAL': 'Документ не является оригиналом',
            'select_language': 'Выбрать страну',
            'select_language_desc':
                'Пожалуйста выберите страну для продолжения проверки удостоверения личности.',
            'select_template': 'Выберите тип шаблона',
            'select_template_desc':
                'Для продолжения проверки удостоверения личности, полжалуйста выберите тип шаблона.',
            'FOREIGNIDBACK': 'Удостоверение личности иностранного государства (Back)',
            'Go Back To Dashboard': 'Вернуться к панели управления',
            'ID-Front': 'Лицевая сторона удостоверения личности',
            'ID-Back': 'Задняя сторона удостоверения личности',
            'ID-NFC': 'Чтение NFC',
            'Hologram': 'Видео голограммы',
            'Others': 'Удостоверения личности всего мира',
            'Acceptance Threshold': 'Порог принятия',
            'Security Threshold': 'Порог безопасности',
            'completed': 'Завершено',
            'pending': 'В ожидании',
            'Role Groups': 'Группы ролей',
            'Pending Group Request': 'Запрос на одобрение группы',
            'Pending Group Requests': 'Ожидающие одобрения групп',
            'Request Type': 'Тип запроса',
            'Role Group Create': 'Создать группу ролей',
            'Role Group Update': 'Обновить группу ролей',
            'Role Group Delete': 'Удалить группу ролей',
            'User Create': 'Создать пользователя',
            'User Update': 'Обновить пользователя',
            'Old': 'Старый',
            'New': 'Новый',
            'Add New Role Group': 'Добавить новую группу ролей',
            'Role Group Name': 'Название группы ролей',
            'Roles': 'Роли',
            'Checker Username': 'Имя пользователя проверяющего',
            'Select Request Type': 'Выберите тип запроса',
            'Select roles': 'Выберите роли',
            'Select checker': 'Выберите проверяющего',
            'Enter role group name': 'Введите название группы ролей',
            'Enter checker username or email': 'Введите имя пользователя или email проверяющего',
            'No roles available. Please create role groups first.': 'Роли недоступны. Пожалуйста, сначала создайте группы ролей.',
            'Approve Request': 'Одобрить запрос',
            'Decline Request': 'Отклонить запрос',
            'Do you want to approve the creation of role group "{{name}}" with roles: {{roles}}?': 'Вы хотите одобрить создание группы ролей "{{name}}" с ролями: {{roles}}?',
            'Do you want to approve the update of role group "{{name}}" with roles: {{roles}}?': 'Вы хотите одобрить обновление группы ролей "{{name}}" с ролями: {{roles}}?',
            'Do you want to approve the deletion of role group "{{name}}"?': 'Вы хотите одобрить удаление группы ролей "{{name}}"?',
            'Do you want to approve the creation of user "{{user}}"?': 'Вы хотите одобрить создание пользователя "{{user}}"?',
            'Do you want to approve the update of user "{{user}}"?': 'Вы хотите одобрить обновление пользователя "{{user}}"?',
            'Do you want to approve this request?': 'Вы хотите одобрить этот запрос?',
            'Do you want to decline the creation of role group "{{name}}"?': 'Вы хотите отклонить создание группы ролей "{{name}}"?',
            'Do you want to decline the update of role group "{{name}}"?': 'Вы хотите отклонить обновление группы ролей "{{name}}"?',
            'Do you want to decline the deletion of role group "{{name}}"?': 'Вы хотите отклонить удаление группы ролей "{{name}}"?',
            'Do you want to decline the creation of user "{{user}}"?': 'Вы хотите отклонить создание пользователя "{{user}}"?',
            'Do you want to decline the update of user "{{user}}"?': 'Вы хотите отклонить обновление пользователя "{{user}}"?',
            'Do you want to decline this request?': 'Вы хотите отклонить этот запрос?',
            'Role group approved successfully': 'Группа ролей успешно одобрена',
            'Request approved successfully': 'Запрос успешно одобрен',
            'Role group declined successfully': 'Группа ролей успешно отклонена',
            'Request declined successfully': 'Запрос успешно отклонен',
            'Role group creation request sent successfully': 'Запрос на создание группы ролей успешно отправлен',
            'Couldn\'t fetch role groups': 'Не удалось получить группы ролей',
            'Couldn\'t fetch pending group requests': 'Не удалось получить ожидающие запросы групп',
            'Couldn\'t approve request': 'Не удалось одобрить запрос',
            'Couldn\'t decline request': 'Не удалось отклонить запрос',
            'Couldn\'t create role group': 'Не удалось создать группу ролей',
            'Please enter role group name': 'Пожалуйста, введите название группы ролей',
            'Please select at least one role': 'Пожалуйста, выберите хотя бы одну роль',
            'Please enter checker username': 'Пожалуйста, введите имя пользователя проверяющего',
            'No roles': 'Нет ролей',
            'Maker': 'Создатель',
            'Roles / Role Group': 'Роли / Группа ролей',
            'Role Group ID': 'ID группы ролей',
            'Only users with checker or role-checker role can list role groups': 'Только пользователи с ролью checker или role-checker могут просматривать список групп ролей',
            'Edit Role Group': 'Редактировать группу ролей',
            'Delete Role Group': 'Удалить группу ролей',
            'Update Role Group': 'Обновить группу ролей',
            'Role group update request sent successfully': 'Запрос на обновление группы ролей успешно отправлен',
            'Role group deletion request sent successfully': 'Запрос на удаление группы ролей успешно отправлен',
            'Cannot delete role group with assigned users. User count: {{count}}': 'Невозможно удалить группу ролей с назначенными пользователями. Количество пользователей: {{count}}',
            'Warning: This role group has {{count}} assigned user(s).': 'Предупреждение: У этой группы ролей {{count}} назначенных пользователей.',
            'Do you want to delete role group "{{name}}"?': 'Вы хотите удалить группу ролей "{{name}}"?',
            'Couldn\'t update role group': 'Не удалось обновить группу ролей',
            'Couldn\'t delete role group': 'Не удалось удалить группу ролей',
        },
    },
}

let query = queryString.parse(window.location.search)
let lg = null

if (sessionStorage.getItem('lg') === null || sessionStorage.getItem('lg') === '') {
    lg = 'en'
    sessionStorage.setItem('lg', 'en')
} else {
    lg = sessionStorage.getItem('lg')
}

try {
    if (query.lg && query.lg !== '' && query.lg in resources) {
        sessionStorage.setItem('lg', query.lg)
        lg = query.lg
    } else {
        lg = sessionStorage.getItem('lg')
    }
} catch (e) {
    console.log(e)
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: lg,
        keySeparator: false, // we do not use keys in form messages.welcome
        nsSeparator: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    })

export default i18n
